import { getCurrentInstance, inject, isRef, computed, ref, reactive, watch, onBeforeUnmount, onUnmounted, onServerPrefetch, nextTick } from 'vue-demi';
import { provide, inject as inject$1, reactive as reactive$1, ref as ref$1, watch as watch$1, computed as computed$1, onUnmounted as onUnmounted$1, defineComponent, toRef } from '@vue/composition-api';
import { IntrospectionFragmentMatcher, InMemoryCache } from 'apollo-cache-inmemory';
import { ApolloClient } from 'apollo-client';
import { ApolloLink, concat } from 'apollo-link';
import { createHttpLink } from 'apollo-link-http';
import Mustache from 'mustache';
import { getYear, addMonths, addYears, addDays, endOfDay, startOfDay, differenceInDays, isSameDay, differenceInYears, parseISO, format, isValid } from 'date-fns';
import deepEqual from 'deep-equal';
import * as Yup from 'yup';
import { transformAll } from '@demvsystems/yup-ast';
import Vue from 'vue';

var AttributeKindEnum$1;
(function(AttributeKindEnum2) {
  AttributeKindEnum2["Risk"] = "risk";
  AttributeKindEnum2["Coverage"] = "coverage";
})(AttributeKindEnum$1 || (AttributeKindEnum$1 = {}));
var AttributeTypeEnum$1;
(function(AttributeTypeEnum2) {
  AttributeTypeEnum2["Boolean"] = "boolean";
  AttributeTypeEnum2["DateTime"] = "date_time";
  AttributeTypeEnum2["Date"] = "date";
  AttributeTypeEnum2["File"] = "file";
  AttributeTypeEnum2["Group"] = "group";
  AttributeTypeEnum2["Iban"] = "iban";
  AttributeTypeEnum2["Integer"] = "integer";
  AttributeTypeEnum2["List"] = "list";
  AttributeTypeEnum2["Locations"] = "locations";
  AttributeTypeEnum2["Money"] = "money";
  AttributeTypeEnum2["String"] = "string";
  AttributeTypeEnum2["ZipCode"] = "zip_code";
})(AttributeTypeEnum$1 || (AttributeTypeEnum$1 = {}));
var CommissionTypeEnum$1;
(function(CommissionTypeEnum2) {
  CommissionTypeEnum2["OnInvoicing"] = "on_invoicing";
  CommissionTypeEnum2["OnPolicing"] = "on_policing";
})(CommissionTypeEnum$1 || (CommissionTypeEnum$1 = {}));
var CommissionUnitEnum$1;
(function(CommissionUnitEnum2) {
  CommissionUnitEnum2["Percent"] = "percent";
  CommissionUnitEnum2["PerMill"] = "per_mill";
  CommissionUnitEnum2["Absolute"] = "absolute";
})(CommissionUnitEnum$1 || (CommissionUnitEnum$1 = {}));
var CompareOperatorEnum$1;
(function(CompareOperatorEnum2) {
  CompareOperatorEnum2["Equal"] = "EQUAL";
  CompareOperatorEnum2["NotEqual"] = "NOT_EQUAL";
  CompareOperatorEnum2["LessThan"] = "LESS_THAN";
  CompareOperatorEnum2["GreaterThan"] = "GREATER_THAN";
  CompareOperatorEnum2["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
  CompareOperatorEnum2["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
})(CompareOperatorEnum$1 || (CompareOperatorEnum$1 = {}));
var ContentTypeEnum$1;
(function(ContentTypeEnum2) {
  ContentTypeEnum2["AlphaNumeric"] = "alpha_numeric";
  ContentTypeEnum2["Alpha"] = "alpha";
  ContentTypeEnum2["DayMonth"] = "day_month";
  ContentTypeEnum2["Email"] = "email";
  ContentTypeEnum2["Numeric"] = "numeric";
  ContentTypeEnum2["Phone"] = "phone";
})(ContentTypeEnum$1 || (ContentTypeEnum$1 = {}));
var CurrencyEnum$2;
(function(CurrencyEnum2) {
  CurrencyEnum2["Chf"] = "CHF";
  CurrencyEnum2["Eur"] = "EUR";
})(CurrencyEnum$2 || (CurrencyEnum$2 = {}));
var DayConstraintEnum$1;
(function(DayConstraintEnum2) {
  DayConstraintEnum2["StartOfMonth"] = "StartOfMonth";
  DayConstraintEnum2["StartOfYear"] = "StartOfYear";
})(DayConstraintEnum$1 || (DayConstraintEnum$1 = {}));
var DocumentKindEnum$2;
(function(DocumentKindEnum2) {
  DocumentKindEnum2["Static"] = "STATIC";
  DocumentKindEnum2["Dynamic"] = "DYNAMIC";
  DocumentKindEnum2["External"] = "EXTERNAL";
})(DocumentKindEnum$2 || (DocumentKindEnum$2 = {}));
var EqualOperatorEnum$1;
(function(EqualOperatorEnum2) {
  EqualOperatorEnum2["Equal"] = "EQUAL";
  EqualOperatorEnum2["NotEqual"] = "NOT_EQUAL";
})(EqualOperatorEnum$1 || (EqualOperatorEnum$1 = {}));
var NoticePeriodIdentifierEnum$1;
(function(NoticePeriodIdentifierEnum2) {
  NoticePeriodIdentifierEnum2["Days"] = "days";
  NoticePeriodIdentifierEnum2["Weeks"] = "weeks";
  NoticePeriodIdentifierEnum2["Months"] = "months";
  NoticePeriodIdentifierEnum2["Years"] = "years";
})(NoticePeriodIdentifierEnum$1 || (NoticePeriodIdentifierEnum$1 = {}));
var OutcomeTypeEnum$2;
(function(OutcomeTypeEnum2) {
  OutcomeTypeEnum2["Accept"] = "accept";
  OutcomeTypeEnum2["Deny"] = "deny";
  OutcomeTypeEnum2["Underwriting"] = "underwriting";
})(OutcomeTypeEnum$2 || (OutcomeTypeEnum$2 = {}));
var PricingTypeEnum$1;
(function(PricingTypeEnum2) {
  PricingTypeEnum2["Internal"] = "internal";
  PricingTypeEnum2["External"] = "external";
  PricingTypeEnum2["Middleware"] = "middleware";
})(PricingTypeEnum$1 || (PricingTypeEnum$1 = {}));
var TariffMappingFileFormatEnum$1;
(function(TariffMappingFileFormatEnum2) {
  TariffMappingFileFormatEnum2["Csv"] = "csv";
  TariffMappingFileFormatEnum2["Xlsx"] = "xlsx";
})(TariffMappingFileFormatEnum$1 || (TariffMappingFileFormatEnum$1 = {}));
var TerminationDateIdentifierEnum$1;
(function(TerminationDateIdentifierEnum2) {
  TerminationDateIdentifierEnum2["EndOfWeek"] = "end_of_week";
  TerminationDateIdentifierEnum2["EndOfMonth"] = "end_of_month";
  TerminationDateIdentifierEnum2["EndOfYear"] = "end_of_year";
  TerminationDateIdentifierEnum2["EndOfInsurancePeriod"] = "end_of_insurance_period";
  TerminationDateIdentifierEnum2["EndOfNextInsurancePeriod"] = "end_of_next_insurance_period";
  TerminationDateIdentifierEnum2["StartOfInsurance"] = "start_of_insurance";
  TerminationDateIdentifierEnum2["AppliedAt"] = "applied_at";
  TerminationDateIdentifierEnum2["PolicedAt"] = "policed_at";
  TerminationDateIdentifierEnum2["ThisDay"] = "this_day";
  TerminationDateIdentifierEnum2["ExpirationDate"] = "expiration_date";
  TerminationDateIdentifierEnum2["ValidAt"] = "valid_at";
})(TerminationDateIdentifierEnum$1 || (TerminationDateIdentifierEnum$1 = {}));
var VersionStatusEnum$1;
(function(VersionStatusEnum2) {
  VersionStatusEnum2["Draft"] = "draft";
  VersionStatusEnum2["Active"] = "active";
  VersionStatusEnum2["Inactive"] = "inactive";
  VersionStatusEnum2["Scheduled"] = "scheduled";
})(VersionStatusEnum$1 || (VersionStatusEnum$1 = {}));

var CurrencyEnum$1;
(function(CurrencyEnum2) {
  CurrencyEnum2["Eur"] = "EUR";
  CurrencyEnum2["Chf"] = "CHF";
})(CurrencyEnum$1 || (CurrencyEnum$1 = {}));
var DocumentKindEnum$1;
(function(DocumentKindEnum2) {
  DocumentKindEnum2["Static"] = "STATIC";
  DocumentKindEnum2["Dynamic"] = "DYNAMIC";
  DocumentKindEnum2["External"] = "EXTERNAL";
})(DocumentKindEnum$1 || (DocumentKindEnum$1 = {}));
var OutcomeTypeEnum$1;
(function(OutcomeTypeEnum2) {
  OutcomeTypeEnum2["Accept"] = "accept";
  OutcomeTypeEnum2["Deny"] = "deny";
  OutcomeTypeEnum2["Underwriting"] = "underwriting";
})(OutcomeTypeEnum$1 || (OutcomeTypeEnum$1 = {}));
var SourceKind$1;
(function(SourceKind2) {
  SourceKind2["Attribute"] = "attribute";
  SourceKind2["ModuleSelection"] = "moduleSelection";
  SourceKind2["DocumentIds"] = "documentIds";
})(SourceKind$1 || (SourceKind$1 = {}));

function isField(item) {
  if (!item) {
    return false;
  }
  const type = item.__typename;
  switch (type) {
    case "GroupField":
    case "TextField":
    case "TextAreaField":
    case "NumberField":
    case "BooleanField":
    case "DateField":
    case "SelectField":
    case "RadioGroupField":
    case "MoneyField":
    case "ZipCityField":
    case "LocationsField":
    case "UploadField":
    case "IbanField":
    case "ModuleSelectionField":
      return true;
    case "ContentItem":
    case "DownloadItem":
    case "SummaryItem":
    case "RowItem":
    case "TariffItem":
      return false;
  }
}
function shouldValidate(item) {
  return isField(item) || (item === null || item === void 0 ? void 0 : item.__typename) === "DownloadItem";
}

/* eslint-disable no-undefined,no-param-reassign,no-shadow */

/**
 * Throttle execution of a function. Especially useful for rate limiting
 * execution of handlers on events like resize and scroll.
 *
 * @param  {number}    delay -          A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}   [noTrailing] -   Optional, defaults to false. If noTrailing is true, callback will only execute every `delay` milliseconds while the
 *                                    throttled-function is being called. If noTrailing is false or unspecified, callback will be executed one final time
 *                                    after the last throttled-function call. (After the throttled-function has not been called for `delay` milliseconds,
 *                                    the internal counter is reset).
 * @param  {Function}  callback -       A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                    to `callback` when the throttled-function is executed.
 * @param  {boolean}   [debounceMode] - If `debounceMode` is true (at begin), schedule `clear` to execute after `delay` ms. If `debounceMode` is false (at end),
 *                                    schedule `callback` to execute after `delay` ms.
 *
 * @returns {Function}  A new, throttled, function.
 */
function throttle (delay, noTrailing, callback, debounceMode) {
  /*
   * After wrapper has stopped being called, this timeout ensures that
   * `callback` is executed at the proper times in `throttle` and `end`
   * debounce modes.
   */
  var timeoutID;
  var cancelled = false; // Keep track of the last time `callback` was executed.

  var lastExec = 0; // Function to clear existing timeout

  function clearExistingTimeout() {
    if (timeoutID) {
      clearTimeout(timeoutID);
    }
  } // Function to cancel next exec


  function cancel() {
    clearExistingTimeout();
    cancelled = true;
  } // `noTrailing` defaults to falsy.


  if (typeof noTrailing !== 'boolean') {
    debounceMode = callback;
    callback = noTrailing;
    noTrailing = undefined;
  }
  /*
   * The `wrapper` function encapsulates all of the throttling / debouncing
   * functionality and when executed will limit the rate at which `callback`
   * is executed.
   */


  function wrapper() {
    for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
      arguments_[_key] = arguments[_key];
    }

    var self = this;
    var elapsed = Date.now() - lastExec;

    if (cancelled) {
      return;
    } // Execute `callback` and update the `lastExec` timestamp.


    function exec() {
      lastExec = Date.now();
      callback.apply(self, arguments_);
    }
    /*
     * If `debounceMode` is true (at begin) this is used to clear the flag
     * to allow future `callback` executions.
     */


    function clear() {
      timeoutID = undefined;
    }

    if (debounceMode && !timeoutID) {
      /*
       * Since `wrapper` is being called for the first time and
       * `debounceMode` is true (at begin), execute `callback`.
       */
      exec();
    }

    clearExistingTimeout();

    if (debounceMode === undefined && elapsed > delay) {
      /*
       * In throttle mode, if `delay` time has been exceeded, execute
       * `callback`.
       */
      exec();
    } else if (noTrailing !== true) {
      /*
       * In trailing throttle mode, since `delay` time has not been
       * exceeded, schedule `callback` to execute `delay` ms after most
       * recent execution.
       *
       * If `debounceMode` is true (at begin), schedule `clear` to execute
       * after `delay` ms.
       *
       * If `debounceMode` is false (at end), schedule `callback` to
       * execute after `delay` ms.
       */
      timeoutID = setTimeout(debounceMode ? clear : exec, debounceMode === undefined ? delay - elapsed : delay);
    }
  }

  wrapper.cancel = cancel; // Return the wrapper function.

  return wrapper;
}

/* eslint-disable no-undefined */
/**
 * Debounce execution of a function. Debouncing, unlike throttling,
 * guarantees that a function is only executed a single time, either at the
 * very beginning of a series of calls, or at the very end.
 *
 * @param  {number}   delay -         A zero-or-greater delay in milliseconds. For event callbacks, values around 100 or 250 (or even higher) are most useful.
 * @param  {boolean}  [atBegin] -     Optional, defaults to false. If atBegin is false or unspecified, callback will only be executed `delay` milliseconds
 *                                  after the last debounced-function call. If atBegin is true, callback will be executed only at the first debounced-function call.
 *                                  (After the throttled-function has not been called for `delay` milliseconds, the internal counter is reset).
 * @param  {Function} callback -      A function to be executed after delay milliseconds. The `this` context and all arguments are passed through, as-is,
 *                                  to `callback` when the debounced-function is executed.
 *
 * @returns {Function} A new, debounced function.
 */

function debounce (delay, atBegin, callback) {
  return callback === undefined ? throttle(delay, atBegin, false) : throttle(delay, callback, atBegin !== false);
}

var DefaultApolloClient = Symbol('default-apollo-client');
var ApolloClients = Symbol('apollo-clients');
function resolveDefaultClient(providedApolloClients, providedApolloClient) {
    var resolvedClient = providedApolloClients
        ? providedApolloClients.default
        : providedApolloClient;
    return resolvedClient;
}
function resolveClientWithId(providedApolloClients, clientId) {
    if (!providedApolloClients) {
        throw new Error("No apolloClients injection found, tried to resolve '" + clientId + "' clientId");
    }
    return providedApolloClients[clientId];
}
function useApolloClient(clientId) {
    var resolveImpl;
    if (!getCurrentInstance()) {
        resolveImpl = function () { return currentApolloClient; };
    }
    else {
        var providedApolloClients_1 = inject(ApolloClients, null);
        var providedApolloClient_1 = inject(DefaultApolloClient, null);
        resolveImpl = function (id) {
            if (id) {
                return resolveClientWithId(providedApolloClients_1, id);
            }
            return resolveDefaultClient(providedApolloClients_1, providedApolloClient_1);
        };
    }
    function resolveClient(id) {
        if (id === void 0) { id = clientId; }
        var client = resolveImpl(id);
        if (!client) {
            throw new Error("Apollo client with id " + (id || 'default') + " not found. Use provideApolloClient() if you are outside of a component setup.");
        }
        return client;
    }
    return {
        resolveClient: resolveClient,
        get client() {
            return resolveClient();
        },
    };
}
var currentApolloClient;

function paramToRef(param) {
    if (isRef(param)) {
        return param;
    }
    else if (typeof param === 'function') {
        return computed(param);
    }
    else {
        return ref(param);
    }
}

function paramToReactive(param) {
    if (isRef(param)) {
        return param;
    }
    else if (typeof param === 'function') {
        return computed(param);
    }
    else if (param) {
        return reactive(param);
    }
    else {
        return param;
    }
}

function useEventHook() {
    var fns = [];
    function on(fn) {
        fns.push(fn);
        return {
            off: function () { return off(fn); },
        };
    }
    function off(fn) {
        var index = fns.indexOf(fn);
        if (index !== -1) {
            fns.splice(index, 1);
        }
    }
    function trigger(param) {
        for (var _i = 0, fns_1 = fns; _i < fns_1.length; _i++) {
            var fn = fns_1[_i];
            fn(param);
        }
    }
    return {
        on: on,
        off: off,
        trigger: trigger,
    };
}

function getAppTracking() {
    var vm = getCurrentInstance();
    var root = vm.$root || vm.root;
    var appTracking;
    if (!root._apolloAppTracking) {
        // Add per Vue tracking
        appTracking = root._apolloAppTracking = {
            queries: ref(0),
            mutations: ref(0),
            subscriptions: ref(0),
            components: new Map(),
        };
    }
    else {
        appTracking = root._apolloAppTracking;
    }
    return {
        appTracking: appTracking,
    };
}
function getCurrentTracking() {
    var vm = getCurrentInstance();
    if (!vm) {
        throw new Error('getCurrentTracking must be used during a component setup');
    }
    var appTracking = getAppTracking().appTracking;
    var tracking;
    if (!appTracking.components.has(vm)) {
        // Add per-component tracking
        appTracking.components.set(vm, tracking = {
            queries: ref(0),
            mutations: ref(0),
            subscriptions: ref(0),
        });
        // Cleanup
        onUnmounted(function () {
            appTracking.components.delete(vm);
        });
    }
    else {
        tracking = appTracking.components.get(vm);
    }
    return {
        appTracking: appTracking,
        tracking: tracking,
    };
}
function track(loading, type) {
    var _a = getCurrentTracking(), appTracking = _a.appTracking, tracking = _a.tracking;
    watch(loading, function (value, oldValue) {
        if (oldValue != null && value !== oldValue) {
            var mod = value ? 1 : -1;
            tracking[type].value += mod;
            appTracking[type].value += mod;
        }
    }, {
        immediate: true,
    });
    onBeforeUnmount(function () {
        if (loading.value) {
            tracking[type].value--;
            appTracking[type].value--;
        }
    });
}
function trackQuery(loading) {
    track(loading, 'queries');
}
function trackMutation(loading) {
    track(loading, 'mutations');
}

var __assign$f = (undefined && undefined.__assign) || function () {
    __assign$f = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$f.apply(this, arguments);
};
function useQuery(document, variables, options) {
    return useQueryImpl(document, variables, options);
}
function useQueryImpl(document, variables, options, lazy) {
    if (lazy === void 0) { lazy = false; }
    // Is on server?
    var vm = getCurrentInstance();
    var isServer = vm === null || vm === void 0 ? void 0 : vm.$isServer;
    if (variables == null)
        variables = ref();
    if (options == null)
        options = {};
    var documentRef = paramToRef(document);
    var variablesRef = paramToRef(variables);
    var optionsRef = paramToReactive(options);
    // Result
    /**
     * Result from the query
     */
    var result = ref();
    var resultEvent = useEventHook();
    var error = ref(null);
    var errorEvent = useEventHook();
    // Loading
    /**
     * Indicates if a network request is pending
     */
    var loading = ref(false);
    vm && trackQuery(loading);
    var networkStatus = ref();
    // SSR
    var firstResolve;
    var firstReject;
    onServerPrefetch === null || onServerPrefetch === void 0 ? void 0 : onServerPrefetch(function () {
        if (!isEnabled.value || (isServer && currentOptions.value.prefetch === false))
            return;
        return new Promise(function (resolve, reject) {
            firstResolve = function () {
                resolve();
                firstResolve = undefined;
                firstReject = undefined;
            };
            firstReject = function (error) {
                reject(error);
                firstResolve = undefined;
                firstReject = undefined;
            };
        }).then(stop).catch(stop);
    });
    // Apollo Client
    var resolveClient = useApolloClient().resolveClient;
    // Query
    var query = ref();
    var observer;
    var started = false;
    /**
     * Starts watching the query
     */
    function start() {
        if (started || !isEnabled.value ||
            (isServer && currentOptions.value.prefetch === false)) {
            if (firstResolve)
                firstResolve();
            return;
        }
        started = true;
        loading.value = true;
        var client = resolveClient(currentOptions.value.clientId);
        query.value = client.watchQuery(__assign$f(__assign$f({ query: currentDocument, variables: currentVariables }, currentOptions.value), isServer ? {
            fetchPolicy: 'network-only',
        } : {}));
        startQuerySubscription();
        if (!isServer && (currentOptions.value.fetchPolicy !== 'no-cache' || currentOptions.value.notifyOnNetworkStatusChange)) {
            var currentResult = query.value.getCurrentResult();
            if (!currentResult.loading || currentOptions.value.notifyOnNetworkStatusChange) {
                onNextResult(currentResult);
            }
        }
        if (!isServer) {
            for (var _i = 0, subscribeToMoreItems_1 = subscribeToMoreItems; _i < subscribeToMoreItems_1.length; _i++) {
                var item = subscribeToMoreItems_1[_i];
                addSubscribeToMore(item);
            }
        }
    }
    function startQuerySubscription() {
        if (observer && !observer.closed)
            return;
        if (!query.value)
            return;
        // Create subscription
        observer = query.value.subscribe({
            next: onNextResult,
            error: onError,
        });
    }
    function onNextResult(queryResult) {
        var _a;
        processNextResult(queryResult);
        // Result errors
        // This is set when `errorPolicy` is `all`
        if ((_a = queryResult.errors) === null || _a === void 0 ? void 0 : _a.length) {
            var e = new Error("GraphQL error: " + queryResult.errors.map(function (e) { return e.message; }).join(' | '));
            Object.assign(e, {
                graphQLErrors: queryResult.errors,
                networkError: null,
            });
            processError(e);
        }
        else {
            if (firstResolve) {
                firstResolve();
                stop();
            }
        }
    }
    function processNextResult(queryResult) {
        result.value = queryResult.data && Object.keys(queryResult.data).length === 0 ? null : queryResult.data;
        loading.value = queryResult.loading;
        networkStatus.value = queryResult.networkStatus;
        resultEvent.trigger(queryResult);
    }
    function onError(queryError) {
        processNextResult(query.value.getCurrentResult());
        processError(queryError);
        if (firstReject) {
            firstReject(queryError);
            stop();
        }
        // The observable closes the sub if an error occurs
        resubscribeToQuery();
    }
    function processError(queryError) {
        error.value = queryError;
        loading.value = false;
        networkStatus.value = 8;
        errorEvent.trigger(queryError);
    }
    function resubscribeToQuery() {
        if (!query.value)
            return;
        var lastError = query.value.getLastError();
        var lastResult = query.value.getLastResult();
        query.value.resetLastResults();
        startQuerySubscription();
        Object.assign(query.value, { lastError: lastError, lastResult: lastResult });
    }
    var onStopHandlers = [];
    /**
     * Stop watching the query
     */
    function stop() {
        if (firstResolve)
            firstResolve();
        if (!started)
            return;
        started = false;
        loading.value = false;
        onStopHandlers.forEach(function (handler) { return handler(); });
        onStopHandlers = [];
        if (query.value) {
            query.value.stopPolling();
            query.value = null;
        }
        if (observer) {
            observer.unsubscribe();
            observer = null;
        }
    }
    // Restart
    var restarting = false;
    /**
     * Queue a restart of the query (on next tick) if it is already active
     */
    function baseRestart() {
        if (!started || restarting)
            return;
        restarting = true;
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        nextTick(function () {
            if (started) {
                stop();
                start();
            }
            restarting = false;
        });
    }
    var debouncedRestart;
    var isRestartDebounceSetup = false;
    function updateRestartFn() {
        // On server, will be called before currentOptions is initialized
        // @TODO investigate
        if (!currentOptions) {
            debouncedRestart = baseRestart;
        }
        else {
            if (currentOptions.value.throttle) {
                debouncedRestart = throttle(currentOptions.value.throttle, baseRestart);
            }
            else if (currentOptions.value.debounce) {
                debouncedRestart = debounce(currentOptions.value.debounce, baseRestart);
            }
            else {
                debouncedRestart = baseRestart;
            }
            isRestartDebounceSetup = true;
        }
    }
    function restart() {
        if (!isRestartDebounceSetup)
            updateRestartFn();
        debouncedRestart();
    }
    // Applying document
    var currentDocument;
    watch(documentRef, function (value) {
        currentDocument = value;
        restart();
    }, {
        immediate: true,
    });
    // Applying variables
    var currentVariables;
    var currentVariablesSerialized;
    watch(variablesRef, function (value, oldValue) {
        var serialized = JSON.stringify(value);
        if (serialized !== currentVariablesSerialized) {
            currentVariables = value;
            restart();
        }
        currentVariablesSerialized = serialized;
    }, {
        deep: true,
        immediate: true,
    });
    // Applying options
    var currentOptions = ref();
    watch(function () { return isRef(optionsRef) ? optionsRef.value : optionsRef; }, function (value) {
        if (currentOptions.value && (currentOptions.value.throttle !== value.throttle ||
            currentOptions.value.debounce !== value.debounce)) {
            updateRestartFn();
        }
        currentOptions.value = value;
        restart();
    }, {
        deep: true,
        immediate: true,
    });
    // Fefetch
    function refetch(variables) {
        if (variables === void 0) { variables = null; }
        if (query.value) {
            if (variables) {
                currentVariables = variables;
            }
            return query.value.refetch(variables);
        }
    }
    // Fetch more
    function fetchMore(options) {
        if (query.value) {
            return query.value.fetchMore(options);
        }
    }
    // Subscribe to more
    var subscribeToMoreItems = [];
    function subscribeToMore(options) {
        if (isServer)
            return;
        var optionsRef = paramToRef(options);
        watch(optionsRef, function (value, oldValue, onCleanup) {
            var index = subscribeToMoreItems.findIndex(function (item) { return item.options === oldValue; });
            if (index !== -1) {
                subscribeToMoreItems.splice(index, 1);
            }
            var item = {
                options: value,
                unsubscribeFns: [],
            };
            subscribeToMoreItems.push(item);
            addSubscribeToMore(item);
            onCleanup(function () {
                item.unsubscribeFns.forEach(function (fn) { return fn(); });
                item.unsubscribeFns = [];
            });
        }, {
            immediate: true,
        });
    }
    function addSubscribeToMore(item) {
        if (!started)
            return;
        var unsubscribe = query.value.subscribeToMore(item.options);
        onStopHandlers.push(unsubscribe);
        item.unsubscribeFns.push(unsubscribe);
    }
    // Enabled state
    var forceDisabled = ref(lazy);
    var enabledOption = computed(function () { return !currentOptions.value || currentOptions.value.enabled == null || currentOptions.value.enabled; });
    var isEnabled = computed(function () { return enabledOption.value && !forceDisabled.value; });
    // Auto start & stop
    watch(isEnabled, function (value) {
        if (value) {
            start();
        }
        else {
            stop();
        }
    }, {
        immediate: true,
    });
    // Teardown
    vm && onBeforeUnmount(function () {
        stop();
        subscribeToMoreItems.length = 0;
    });
    return {
        result: result,
        loading: loading,
        networkStatus: networkStatus,
        error: error,
        start: start,
        stop: stop,
        restart: restart,
        forceDisabled: forceDisabled,
        document: documentRef,
        variables: variablesRef,
        options: optionsRef,
        query: query,
        refetch: refetch,
        fetchMore: fetchMore,
        subscribeToMore: subscribeToMore,
        onResult: resultEvent.on,
        onError: errorEvent.on,
    };
}

var __assign$e = (undefined && undefined.__assign) || function () {
    __assign$e = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$e.apply(this, arguments);
};

var __assign$d = (undefined && undefined.__assign) || function () {
    __assign$d = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$d.apply(this, arguments);
};
var __awaiter = (undefined && undefined.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
function useMutation(document, options) {
    if (!options)
        options = {};
    var loading = ref(false);
    trackMutation(loading);
    var error = ref(null);
    var called = ref(false);
    var doneEvent = useEventHook();
    var errorEvent = useEventHook();
    // Apollo Client
    var resolveClient = useApolloClient().resolveClient;
    function mutate(variables, overrideOptions) {
        if (overrideOptions === void 0) { overrideOptions = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var currentDocument, currentOptions, client, result, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (typeof document === 'function') {
                            currentDocument = document();
                        }
                        else if (isRef(document)) {
                            currentDocument = document.value;
                        }
                        else {
                            currentDocument = document;
                        }
                        if (typeof options === 'function') {
                            currentOptions = options();
                        }
                        else if (isRef(options)) {
                            currentOptions = options.value;
                        }
                        else {
                            currentOptions = options;
                        }
                        client = resolveClient(currentOptions.clientId);
                        error.value = null;
                        loading.value = true;
                        called.value = true;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, client.mutate(__assign$d(__assign$d(__assign$d({ mutation: currentDocument }, currentOptions), overrideOptions), { variables: __assign$d(__assign$d({}, currentOptions.variables || {}), variables || {}) }))];
                    case 2:
                        result = _a.sent();
                        loading.value = false;
                        doneEvent.trigger(result);
                        return [2 /*return*/, result];
                    case 3:
                        e_1 = _a.sent();
                        error.value = e_1;
                        loading.value = false;
                        errorEvent.trigger(e_1);
                        throw e_1;
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    onBeforeUnmount(function () {
        loading.value = false;
    });
    return {
        mutate: mutate,
        loading: loading,
        error: error,
        called: called,
        onDone: doneEvent.on,
        onError: errorEvent.on,
    };
}

var __assign$c = (undefined && undefined.__assign) || function () {
    __assign$c = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$c.apply(this, arguments);
};

var AttributeKindEnum;
(function(AttributeKindEnum2) {
  AttributeKindEnum2["Coverage"] = "coverage";
  AttributeKindEnum2["Risk"] = "risk";
})(AttributeKindEnum || (AttributeKindEnum = {}));
var AttributeTypeEnum;
(function(AttributeTypeEnum2) {
  AttributeTypeEnum2["Boolean"] = "boolean";
  AttributeTypeEnum2["Date"] = "date";
  AttributeTypeEnum2["DateTime"] = "date_time";
  AttributeTypeEnum2["File"] = "file";
  AttributeTypeEnum2["Group"] = "group";
  AttributeTypeEnum2["Iban"] = "iban";
  AttributeTypeEnum2["Integer"] = "integer";
  AttributeTypeEnum2["List"] = "list";
  AttributeTypeEnum2["Locations"] = "locations";
  AttributeTypeEnum2["Money"] = "money";
  AttributeTypeEnum2["String"] = "string";
  AttributeTypeEnum2["ZipCode"] = "zip_code";
})(AttributeTypeEnum || (AttributeTypeEnum = {}));
var CommissionTypeEnum;
(function(CommissionTypeEnum2) {
  CommissionTypeEnum2["OnInvoicing"] = "on_invoicing";
  CommissionTypeEnum2["OnPolicing"] = "on_policing";
})(CommissionTypeEnum || (CommissionTypeEnum = {}));
var CommissionUnitEnum;
(function(CommissionUnitEnum2) {
  CommissionUnitEnum2["Absolute"] = "absolute";
  CommissionUnitEnum2["PerMill"] = "per_mill";
  CommissionUnitEnum2["Percent"] = "percent";
})(CommissionUnitEnum || (CommissionUnitEnum = {}));
var CompareOperatorEnum;
(function(CompareOperatorEnum2) {
  CompareOperatorEnum2["Equal"] = "EQUAL";
  CompareOperatorEnum2["GreaterThan"] = "GREATER_THAN";
  CompareOperatorEnum2["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
  CompareOperatorEnum2["LessThan"] = "LESS_THAN";
  CompareOperatorEnum2["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
  CompareOperatorEnum2["NotEqual"] = "NOT_EQUAL";
})(CompareOperatorEnum || (CompareOperatorEnum = {}));
var ContentTypeEnum;
(function(ContentTypeEnum2) {
  ContentTypeEnum2["Alpha"] = "alpha";
  ContentTypeEnum2["AlphaNumeric"] = "alpha_numeric";
  ContentTypeEnum2["DayMonth"] = "day_month";
  ContentTypeEnum2["Email"] = "email";
  ContentTypeEnum2["Numeric"] = "numeric";
  ContentTypeEnum2["Phone"] = "phone";
})(ContentTypeEnum || (ContentTypeEnum = {}));
var CurrencyEnum;
(function(CurrencyEnum2) {
  CurrencyEnum2["Chf"] = "CHF";
  CurrencyEnum2["Eur"] = "EUR";
})(CurrencyEnum || (CurrencyEnum = {}));
var DayConstraintEnum;
(function(DayConstraintEnum2) {
  DayConstraintEnum2["StartOfMonth"] = "StartOfMonth";
  DayConstraintEnum2["StartOfYear"] = "StartOfYear";
})(DayConstraintEnum || (DayConstraintEnum = {}));
var DocumentKindEnum;
(function(DocumentKindEnum2) {
  DocumentKindEnum2["Dynamic"] = "DYNAMIC";
  DocumentKindEnum2["External"] = "EXTERNAL";
  DocumentKindEnum2["Static"] = "STATIC";
})(DocumentKindEnum || (DocumentKindEnum = {}));
var EqualOperatorEnum;
(function(EqualOperatorEnum2) {
  EqualOperatorEnum2["Equal"] = "EQUAL";
  EqualOperatorEnum2["NotEqual"] = "NOT_EQUAL";
})(EqualOperatorEnum || (EqualOperatorEnum = {}));
var NoticePeriodIdentifierEnum;
(function(NoticePeriodIdentifierEnum2) {
  NoticePeriodIdentifierEnum2["Days"] = "days";
  NoticePeriodIdentifierEnum2["Months"] = "months";
  NoticePeriodIdentifierEnum2["Weeks"] = "weeks";
  NoticePeriodIdentifierEnum2["Years"] = "years";
})(NoticePeriodIdentifierEnum || (NoticePeriodIdentifierEnum = {}));
var OutcomeTypeEnum;
(function(OutcomeTypeEnum2) {
  OutcomeTypeEnum2["Accept"] = "accept";
  OutcomeTypeEnum2["Deny"] = "deny";
  OutcomeTypeEnum2["Underwriting"] = "underwriting";
})(OutcomeTypeEnum || (OutcomeTypeEnum = {}));
var PricingTypeEnum;
(function(PricingTypeEnum2) {
  PricingTypeEnum2["External"] = "external";
  PricingTypeEnum2["Internal"] = "internal";
  PricingTypeEnum2["Middleware"] = "middleware";
})(PricingTypeEnum || (PricingTypeEnum = {}));
var SourceKind;
(function(SourceKind2) {
  SourceKind2["Attribute"] = "attribute";
  SourceKind2["ModuleSelection"] = "moduleSelection";
  SourceKind2["DocumentIds"] = "documentIds";
})(SourceKind || (SourceKind = {}));
var TariffMappingFileFormatEnum;
(function(TariffMappingFileFormatEnum2) {
  TariffMappingFileFormatEnum2["Csv"] = "csv";
  TariffMappingFileFormatEnum2["Xlsx"] = "xlsx";
})(TariffMappingFileFormatEnum || (TariffMappingFileFormatEnum = {}));
var TerminationDateIdentifierEnum;
(function(TerminationDateIdentifierEnum2) {
  TerminationDateIdentifierEnum2["AppliedAt"] = "applied_at";
  TerminationDateIdentifierEnum2["EndOfInsurancePeriod"] = "end_of_insurance_period";
  TerminationDateIdentifierEnum2["EndOfMonth"] = "end_of_month";
  TerminationDateIdentifierEnum2["EndOfNextInsurancePeriod"] = "end_of_next_insurance_period";
  TerminationDateIdentifierEnum2["EndOfWeek"] = "end_of_week";
  TerminationDateIdentifierEnum2["EndOfYear"] = "end_of_year";
  TerminationDateIdentifierEnum2["ExpirationDate"] = "expiration_date";
  TerminationDateIdentifierEnum2["PolicedAt"] = "policed_at";
  TerminationDateIdentifierEnum2["StartOfInsurance"] = "start_of_insurance";
  TerminationDateIdentifierEnum2["ThisDay"] = "this_day";
  TerminationDateIdentifierEnum2["ValidAt"] = "valid_at";
})(TerminationDateIdentifierEnum || (TerminationDateIdentifierEnum = {}));
var VersionStatusEnum;
(function(VersionStatusEnum2) {
  VersionStatusEnum2["Active"] = "active";
  VersionStatusEnum2["Draft"] = "draft";
  VersionStatusEnum2["Inactive"] = "inactive";
  VersionStatusEnum2["Scheduled"] = "scheduled";
})(VersionStatusEnum || (VersionStatusEnum = {}));
const SaveApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {kind: "Name", value: "saveApplication"},
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {kind: "Variable", name: {kind: "Name", value: "application"}},
          type: {
            kind: "NonNullType",
            type: {kind: "NamedType", name: {kind: "Name", value: "SaveApplicationInput"}}
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {kind: "Name", value: "saveApplication"},
            arguments: [
              {
                kind: "Argument",
                name: {kind: "Name", value: "application"},
                value: {kind: "Variable", name: {kind: "Name", value: "application"}}
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {kind: "Field", name: {kind: "Name", value: "__typename"}},
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "ApplicationReference"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "id"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {kind: "NamedType", name: {kind: "Name", value: "Error"}},
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "message"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "UninsurableError"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "code"}},
                      {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                      {kind: "Field", name: {kind: "Name", value: "attributeKey"}}
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "MiddlewareValidationErrors"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "errors"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                            {kind: "Field", name: {kind: "Name", value: "attributeKey"}},
                            {kind: "Field", name: {kind: "Name", value: "message"}},
                            {kind: "Field", name: {kind: "Name", value: "code"}}
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
function useSaveApplicationMutation(options) {
  return useMutation(SaveApplicationDocument, options);
}
const SendApplicationDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "mutation",
      name: {kind: "Name", value: "SendApplication"},
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {kind: "Variable", name: {kind: "Name", value: "applicationData"}},
          type: {
            kind: "NonNullType",
            type: {kind: "NamedType", name: {kind: "Name", value: "SendApplicationInput"}}
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {kind: "Name", value: "sendApplication"},
            arguments: [
              {
                kind: "Argument",
                name: {kind: "Name", value: "application"},
                value: {kind: "Variable", name: {kind: "Name", value: "applicationData"}}
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {kind: "Field", name: {kind: "Name", value: "__typename"}},
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "ApplicationReference"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "id"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {kind: "NamedType", name: {kind: "Name", value: "Error"}},
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "message"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "UninsurableError"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "code"}},
                      {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                      {kind: "Field", name: {kind: "Name", value: "attributeKey"}}
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "MiddlewareValidationErrors"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "errors"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                            {kind: "Field", name: {kind: "Name", value: "attributeKey"}},
                            {kind: "Field", name: {kind: "Name", value: "message"}},
                            {kind: "Field", name: {kind: "Name", value: "code"}}
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
function useSendApplicationMutation(options) {
  return useMutation(SendApplicationDocument, options);
}
const ApplicationDocumentDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {kind: "Name", value: "ApplicationDocument"},
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {kind: "Variable", name: {kind: "Name", value: "input"}},
          type: {
            kind: "NonNullType",
            type: {kind: "NamedType", name: {kind: "Name", value: "ApplicationDocumentInput"}}
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {kind: "Name", value: "applicationDocument"},
            arguments: [
              {
                kind: "Argument",
                name: {kind: "Name", value: "input"},
                value: {kind: "Variable", name: {kind: "Name", value: "input"}}
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {kind: "Field", name: {kind: "Name", value: "__typename"}},
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "ApplicationDocument"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "id"}},
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "file"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "mimeType"}},
                            {kind: "Field", name: {kind: "Name", value: "fileName"}},
                            {kind: "Field", name: {kind: "Name", value: "base64Data"}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {kind: "NamedType", name: {kind: "Name", value: "Error"}},
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "message"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "UninsurableError"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "code"}},
                      {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                      {kind: "Field", name: {kind: "Name", value: "attributeKey"}}
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "MiddlewareValidationErrors"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "errors"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                            {kind: "Field", name: {kind: "Name", value: "attributeKey"}},
                            {kind: "Field", name: {kind: "Name", value: "message"}},
                            {kind: "Field", name: {kind: "Name", value: "code"}}
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
const ApplicationFormDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {kind: "Name", value: "ApplicationForm"},
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {kind: "Variable", name: {kind: "Name", value: "input"}},
          type: {
            kind: "NonNullType",
            type: {kind: "NamedType", name: {kind: "Name", value: "ApplicationFormInput"}}
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {kind: "Name", value: "applicationForm"},
            arguments: [
              {
                kind: "Argument",
                name: {kind: "Name", value: "input"},
                value: {kind: "Variable", name: {kind: "Name", value: "input"}}
              }
            ]
          }
        ]
      }
    }
  ]
};
function useApplicationFormQuery(variables, options = {}) {
  return useQuery(ApplicationFormDocument, variables, options);
}
const ApplicationOutcomeDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {kind: "Name", value: "ApplicationOutcome"},
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {kind: "Variable", name: {kind: "Name", value: "input"}},
          type: {
            kind: "NonNullType",
            type: {kind: "NamedType", name: {kind: "Name", value: "ApplicationDataInput"}}
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {kind: "Name", value: "applicationOutcome"},
            arguments: [
              {
                kind: "Argument",
                name: {kind: "Name", value: "input"},
                value: {kind: "Variable", name: {kind: "Name", value: "input"}}
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {kind: "Field", name: {kind: "Name", value: "__typename"}},
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "OutcomeResults"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "outcomeType"}},
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "reasons"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "key"}},
                            {kind: "Field", name: {kind: "Name", value: "name"}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {kind: "NamedType", name: {kind: "Name", value: "Error"}},
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "message"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "UninsurableError"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "code"}},
                      {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                      {kind: "Field", name: {kind: "Name", value: "attributeKey"}}
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "MiddlewareValidationErrors"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "errors"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                            {kind: "Field", name: {kind: "Name", value: "attributeKey"}},
                            {kind: "Field", name: {kind: "Name", value: "message"}},
                            {kind: "Field", name: {kind: "Name", value: "code"}}
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
const ApplicationPriceDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: {kind: "Name", value: "ApplicationPrice"},
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {kind: "Variable", name: {kind: "Name", value: "input"}},
          type: {
            kind: "NonNullType",
            type: {kind: "NamedType", name: {kind: "Name", value: "ApplicationDataInput"}}
          }
        }
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: {kind: "Name", value: "applicationPrice"},
            arguments: [
              {
                kind: "Argument",
                name: {kind: "Name", value: "input"},
                value: {kind: "Variable", name: {kind: "Name", value: "input"}}
              }
            ],
            selectionSet: {
              kind: "SelectionSet",
              selections: [
                {kind: "Field", name: {kind: "Name", value: "__typename"}},
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "ApplicationPrice"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "totalPremium"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "valueCents"}},
                            {kind: "Field", name: {kind: "Name", value: "currency"}}
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "premia"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                            {
                              kind: "Field",
                              name: {kind: "Name", value: "premium"},
                              selectionSet: {
                                kind: "SelectionSet",
                                selections: [
                                  {kind: "Field", name: {kind: "Name", value: "valueCents"}},
                                  {kind: "Field", name: {kind: "Name", value: "currency"}}
                                ]
                              }
                            }
                          ]
                        }
                      },
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "computedValues"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "key"}},
                            {kind: "Field", name: {kind: "Name", value: "value"}}
                          ]
                        }
                      }
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {kind: "NamedType", name: {kind: "Name", value: "Error"}},
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [{kind: "Field", name: {kind: "Name", value: "message"}}]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "UninsurableError"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {kind: "Field", name: {kind: "Name", value: "code"}},
                      {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                      {kind: "Field", name: {kind: "Name", value: "attributeKey"}}
                    ]
                  }
                },
                {
                  kind: "InlineFragment",
                  typeCondition: {
                    kind: "NamedType",
                    name: {kind: "Name", value: "MiddlewareValidationErrors"}
                  },
                  selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                      {
                        kind: "Field",
                        name: {kind: "Name", value: "errors"},
                        selectionSet: {
                          kind: "SelectionSet",
                          selections: [
                            {kind: "Field", name: {kind: "Name", value: "moduleKey"}},
                            {kind: "Field", name: {kind: "Name", value: "attributeKey"}},
                            {kind: "Field", name: {kind: "Name", value: "message"}},
                            {kind: "Field", name: {kind: "Name", value: "code"}}
                          ]
                        }
                      }
                    ]
                  }
                }
              ]
            }
          }
        ]
      }
    }
  ]
};
function useApplicationPriceQuery(variables, options = {}) {
  return useQuery(ApplicationPriceDocument, variables, options);
}

const result = {
  __schema: {
    types: [
      {
        kind: "UNION",
        name: "ActiveProductVersionResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddBooleanAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "BooleanAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddChannelResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "Channel"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddDateAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DateValueRange"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddDateTimeAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DateTimeValueRange"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddDocumentLanguageResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DocumentLanguage"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddDocumentTypeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DocumentType"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddFileAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "FileAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddGroupAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "GroupAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddIbanAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IbanAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddIntegerAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IntegerValueRange"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddListAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "ListAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddLocationAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "LocationsAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddModuleResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "Module"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddMoneyAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "MoneyValueRange"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddProductVariantResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVariant"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddRulesResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "ListOfNonNullRuleConjunctionWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddStringAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "StringAttribute"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddTariffMappingResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "TariffMapping"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AddZipCodeAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          },
          {
            name: "ZipCodeAttribute"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplicationDocumentResult",
        possibleTypes: [
          {
            name: "ApplicationDocument"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "CalculationError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "MissingRendererForMimeTypeError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplicationFormConfigurationByChannelResult",
        possibleTypes: [
          {
            name: "ApplicationFormConfiguration"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplicationFormConfigurationResult",
        possibleTypes: [
          {
            name: "ApplicationFormConfiguration"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplicationOutcomeResult",
        possibleTypes: [
          {
            name: "OutcomeResults"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "UninsurableError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplicationPriceResult",
        possibleTypes: [
          {
            name: "ApplicationPrice"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "CalculationError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplicationResult",
        possibleTypes: [
          {
            name: "ApplicationReference"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "PremiumMissingError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplyAmendmentResult",
        possibleTypes: [
          {
            name: "Amendment"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "PremiumMissingError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ApplyQuoteResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "PremiumMissingError"
          },
          {
            name: "Quote"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "AuthenticateResult",
        possibleTypes: [
          {
            name: "AuthenticationError"
          },
          {
            name: "NonNullStringWrapper"
          },
          {
            name: "UserLockedError"
          },
          {
            name: "UserNotConfirmedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CalculateOutcomeResult",
        possibleTypes: [
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "OutcomeResults"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ChangePolicyVariantResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "Policy"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "TariffChangeNotPossibleError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ChangeVariantResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "ExpiredQuoteError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "Quote"
          },
          {
            name: "TariffChangeNotPossibleError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ChannelProductConfigurationsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullChannelProductConfigurationWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CommissionSchemeResult",
        possibleTypes: [
          {
            name: "CommissionScheme"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CommissionSchemesResult",
        possibleTypes: [
          {
            name: "ListOfNonNullCommissionSchemeWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CopyPolicyHolderTemplateResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateApplicationFormConfigurationResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "ApplicationFormConfiguration"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateCommissionSchemeAssignmentResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "CommissionSchemeAssignment"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateCommissionSchemeAssignmentsResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "ListOfNonNullCommissionSchemeAssignmentWrapper"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateCommissionSchemeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "CommissionScheme"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateDunningStateResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DunningState"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateProductDraftResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "ArgumentError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateProductResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "Product"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "CreateTerminationReasonResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "TerminationReason"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "CustomItemConfigurationParameter",
        possibleTypes: [
          {
            name: "CustomItemConfigurationBooleanParameter"
          },
          {
            name: "CustomItemConfigurationIntegerParameter"
          },
          {
            name: "CustomItemConfigurationSelectParameter"
          },
          {
            name: "CustomItemConfigurationTextParameter"
          }
        ]
      },
      {
        kind: "UNION",
        name: "DownloadTariffMappingResult",
        possibleTypes: [
          {
            name: "File"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "DunningStateResult",
        possibleTypes: [
          {
            name: "DunningState"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "DunningStatesResult",
        possibleTypes: [
          {
            name: "ListOfNonNullDunningStateWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "DynamicAttribute",
        possibleTypes: [
          {
            name: "BooleanAttribute"
          },
          {
            name: "DateTimeValueRange"
          },
          {
            name: "DateValueRange"
          },
          {
            name: "FileAttribute"
          },
          {
            name: "GroupAttribute"
          },
          {
            name: "IbanAttribute"
          },
          {
            name: "IntegerValueRange"
          },
          {
            name: "ListAttribute"
          },
          {
            name: "LocationsAttribute"
          },
          {
            name: "MoneyValueRange"
          },
          {
            name: "StringAttribute"
          },
          {
            name: "ZipCodeAttribute"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "DynamicAttributeConfiguration",
        possibleTypes: [
          {
            name: "BooleanConfiguration"
          },
          {
            name: "DateConfiguration"
          },
          {
            name: "DateTimeConfiguration"
          },
          {
            name: "FileConfiguration"
          },
          {
            name: "GroupConfiguration"
          },
          {
            name: "IbanConfiguration"
          },
          {
            name: "IntegerConfiguration"
          },
          {
            name: "ListConfiguration"
          },
          {
            name: "LocationsConfiguration"
          },
          {
            name: "MoneyConfiguration"
          },
          {
            name: "StringConfiguration"
          },
          {
            name: "ZipCodeConfiguration"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Error",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "ArgumentError"
          },
          {
            name: "AuthenticationError"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "CalculationError"
          },
          {
            name: "DeleteRestrictionError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "ExpiredQuoteError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "MissingRendererForMimeTypeError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ParseError"
          },
          {
            name: "PremiumError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "PremiumMissingError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "TariffChangeNotPossibleError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "UnknownFileFormatError"
          },
          {
            name: "UserLockedError"
          },
          {
            name: "UserNotConfirmedError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ExportProductVersionResult",
        possibleTypes: [
          {
            name: "File"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "FieldConfiguration",
        possibleTypes: [
          {
            name: "BooleanFieldConfiguration"
          },
          {
            name: "DateFieldConfiguration"
          },
          {
            name: "GroupFieldConfiguration"
          },
          {
            name: "IbanFieldConfiguration"
          },
          {
            name: "LocationsFieldConfiguration"
          },
          {
            name: "MoneyFieldConfiguration"
          },
          {
            name: "NumberFieldConfiguration"
          },
          {
            name: "RadioGroupFieldConfiguration"
          },
          {
            name: "SelectFieldConfiguration"
          },
          {
            name: "TextAreaFieldConfiguration"
          },
          {
            name: "TextFieldConfiguration"
          },
          {
            name: "UploadFieldConfiguration"
          },
          {
            name: "ZipCityFieldConfiguration"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ImportProductVersionResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "ItemConfiguration",
        possibleTypes: [
          {
            name: "BooleanFieldConfiguration"
          },
          {
            name: "ContentItemConfiguration"
          },
          {
            name: "DateFieldConfiguration"
          },
          {
            name: "DownloadItemConfiguration"
          },
          {
            name: "GroupFieldConfiguration"
          },
          {
            name: "IbanFieldConfiguration"
          },
          {
            name: "LocationsFieldConfiguration"
          },
          {
            name: "ModuleSelectionItemConfiguration"
          },
          {
            name: "MoneyFieldConfiguration"
          },
          {
            name: "NumberFieldConfiguration"
          },
          {
            name: "RadioGroupFieldConfiguration"
          },
          {
            name: "SelectFieldConfiguration"
          },
          {
            name: "SummaryItemConfiguration"
          },
          {
            name: "TariffItemConfiguration"
          },
          {
            name: "TextAreaFieldConfiguration"
          },
          {
            name: "TextFieldConfiguration"
          },
          {
            name: "UploadFieldConfiguration"
          },
          {
            name: "ZipCityFieldConfiguration"
          }
        ]
      },
      {
        kind: "UNION",
        name: "LoadAmendmentResult",
        possibleTypes: [
          {
            name: "Amendment"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "SessionExpiredError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "LoadPolicyResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "Policy"
          },
          {
            name: "SessionExpiredError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "LoadProductVersionResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "UNION",
        name: "LoadQuoteResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "ExpiredQuoteError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "Quote"
          }
        ]
      },
      {
        kind: "UNION",
        name: "MappingItemsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullTariffMappingItemWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "MinimalApplicationFormConfigurationsByProductVersionResult",
        possibleTypes: [
          {
            name: "ListOfNonNullMinimalApplicationFormConfigurationWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "MinimalProductVersionResult",
        possibleTypes: [
          {
            name: "MinimalProductVersion"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "MinimalProductVersionsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullMinimalProductVersionWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "PriceRiskResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "CalculationError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumCalculation"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ProductByProductVersionResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "Product"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ProductDraftResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ProductResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "Product"
          }
        ]
      },
      {
        kind: "UNION",
        name: "ProductVersionsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullProductVersionWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "PublishProductDraftResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RefreshTokenResult",
        possibleTypes: [
          {
            name: "AuthenticationError"
          },
          {
            name: "NonNullStringWrapper"
          },
          {
            name: "UserLockedError"
          },
          {
            name: "UserNotConfirmedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveApplicationFormConfigurationResult",
        possibleTypes: [
          {
            name: "NonNullIntegerWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveCommissionSchemeAssignmentResult",
        possibleTypes: [
          {
            name: "CommissionSchemeAssignment"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveCommissionSchemeResult",
        possibleTypes: [
          {
            name: "CommissionScheme"
          },
          {
            name: "DeleteRestrictionError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveDocumentLanguageResult",
        possibleTypes: [
          {
            name: "NonNullIntegerWrapper"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveDocumentTypeResult",
        possibleTypes: [
          {
            name: "DocumentType"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveDunningStateResult",
        possibleTypes: [
          {
            name: "DeleteRestrictionError"
          },
          {
            name: "DunningState"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveDynamicAttributeResult",
        possibleTypes: [
          {
            name: "NonNullDynamicAttributeWrapper"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveModuleResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "Module"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemovePolicyHolderAttributesResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveProductDocumentResult",
        possibleTypes: [
          {
            name: "NonNullIntegerWrapper"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveProductDraftResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NonNullStringWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveProductVariantResult",
        possibleTypes: [
          {
            name: "NonNullIntegerWrapper"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveRulesResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "ListOfNonNullIntegerWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveTariffMappingResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NonNullIntegerWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RemoveTerminationReasonResult",
        possibleTypes: [
          {
            name: "DeleteRestrictionError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "TerminationReason"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RenderContractDocumentResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "CalculationError"
          },
          {
            name: "ContractDocument"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "MissingRendererForMimeTypeError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RenderProductDocumentResult",
        possibleTypes: [
          {
            name: "File"
          },
          {
            name: "MissingRendererForMimeTypeError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "RenderTerminationDocumentResult",
        possibleTypes: [
          {
            name: "File"
          },
          {
            name: "MissingRendererForMimeTypeError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "Rule",
        possibleTypes: [
          {
            name: "BooleanCompareRule"
          },
          {
            name: "ComputedValueCompareRule"
          },
          {
            name: "DateCompareRule"
          },
          {
            name: "DateTimeCompareRule"
          },
          {
            name: "IntegerCompareRule"
          },
          {
            name: "ListCompareRule"
          },
          {
            name: "LocationsHashCompareRule"
          },
          {
            name: "ModuleSelectionRule"
          },
          {
            name: "MoneyValueRangeHashCompareRule"
          },
          {
            name: "PremiumCompareRule"
          },
          {
            name: "StringCompareRule"
          },
          {
            name: "ZipCodeCompareRule"
          }
        ]
      },
      {
        kind: "UNION",
        name: "SaveAmendmentResult",
        possibleTypes: [
          {
            name: "Amendment"
          },
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "PremiumMissingError"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "SaveOutcomesResult",
        possibleTypes: [
          {
            name: "BusinessLogicError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "ListOfNonNullOutcomeWrapper"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "SaveProductChannelsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullChannelProductConfigurationWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "SaveQuoteResult",
        possibleTypes: [
          {
            name: "AuthorizationError"
          },
          {
            name: "BusinessLogicError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MiddlewareValidationErrors"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "PremiumMismatchError"
          },
          {
            name: "PremiumMissingError"
          },
          {
            name: "Quote"
          },
          {
            name: "RequiredFieldMissingError"
          },
          {
            name: "SessionExpiredError"
          },
          {
            name: "UninsurableError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "SaveVariantChannelsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullChannelVariantConfigurationWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "StaticDocumentByLinkHashResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "ProductDocument"
          }
        ]
      },
      {
        kind: "UNION",
        name: "StaticDocumentResult",
        possibleTypes: [
          {
            name: "NonNullStringWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "StaticProductDocumentResult",
        possibleTypes: [
          {
            name: "File"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "INTERFACE",
        name: "SummarizedItemConfiguration",
        possibleTypes: [
          {
            name: "SummarizedContentItemConfiguration"
          },
          {
            name: "SummarizedFieldConfiguration"
          }
        ]
      },
      {
        kind: "UNION",
        name: "TariffResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "Tariff"
          }
        ]
      },
      {
        kind: "UNION",
        name: "TerminationReasonResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "TerminationReason"
          }
        ]
      },
      {
        kind: "UNION",
        name: "TerminationReasonsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullTerminationReasonWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateApplicationFormConfigurationResult",
        possibleTypes: [
          {
            name: "ApplicationFormConfiguration"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateBooleanAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "BooleanAttribute"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateChannelProductConfigurationResult",
        possibleTypes: [
          {
            name: "ChannelProductConfiguration"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateChannelResult",
        possibleTypes: [
          {
            name: "Channel"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateCommissionSchemeResult",
        possibleTypes: [
          {
            name: "CommissionScheme"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateDateAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DateValueRange"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateDateTimeAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DateTimeValueRange"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateDefaultOutcomeTypeResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVersion"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateDocumentLanguageResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DocumentLanguage"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateDocumentTypeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DocumentType"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateDunningStateResult",
        possibleTypes: [
          {
            name: "DunningState"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateFileAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "FileAttribute"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateFormulasResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ParseError"
          },
          {
            name: "Tariff"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateGroupAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "GroupAttribute"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateIbanAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IbanAttribute"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateIntegerAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "IntegerValueRange"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateListAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "ListAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateLocationAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "LocationsAttribute"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateModuleResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "Module"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateMoneyAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "MoneyValueRange"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdatePricingTypeResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "Tariff"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateProductResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "Product"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateProductVariantResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "ProductVariant"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateRulesResult",
        possibleTypes: [
          {
            name: "BusinessLogicError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "ListOfNonNullRuleConjunctionWrapper"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateStringAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "StringAttribute"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateTariffMappingResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "TariffMapping"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateTerminationReasonResult",
        possibleTypes: [
          {
            name: "NotFoundError"
          },
          {
            name: "TerminationReason"
          },
          {
            name: "ValidationErrors"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UpdateZipCodeAttributeResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "IllegalStateError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ValidationErrors"
          },
          {
            name: "VersionLockedError"
          },
          {
            name: "ZipCodeAttribute"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UploadProductDocumentResult",
        possibleTypes: [
          {
            name: "AlreadyExistsError"
          },
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "ProductDocument"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UploadTariffMappingResult",
        possibleTypes: [
          {
            name: "DraftNotFoundError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "TariffMapping"
          },
          {
            name: "UnknownFileFormatError"
          }
        ]
      },
      {
        kind: "UNION",
        name: "UserResult",
        possibleTypes: [
          {
            name: "AuthenticationError"
          },
          {
            name: "NotFoundError"
          },
          {
            name: "User"
          }
        ]
      },
      {
        kind: "UNION",
        name: "VariantDocumentsResult",
        possibleTypes: [
          {
            name: "ListOfNonNullProductDocumentWrapper"
          },
          {
            name: "NotFoundError"
          }
        ]
      }
    ]
  }
};

var __assign$b = Object.assign;
const fragmentMatcher = new IntrospectionFragmentMatcher({
  introspectionQueryResultData: result
});
function provideApplicationFormContext(options) {
  const httpLink = createHttpLink({
    uri: options.uri
  });
  const cache = new InMemoryCache(__assign$b(__assign$b({}, options === null || options === void 0 ? void 0 : options.inMemoryCache), {
    fragmentMatcher
  }));
  const authMiddleware = new ApolloLink((operation, forward) => {
    if (!options.getAuthToken) {
      return forward(operation);
    }
    const jwtToken = options.getAuthToken();
    if (jwtToken) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${jwtToken}`
        }
      });
    }
    return forward(operation);
  });
  const apolloClient = new ApolloClient({
    link: concat(authMiddleware, httpLink),
    cache,
    defaultOptions: {query: {fetchPolicy: "no-cache"}}
  });
  provide(DefaultApolloClient, apolloClient);
  provide(SCIP_SALES_URI_KEY, options.uri);
}
const SCIP_SALES_URI_KEY = "scipSalesURI";
function injectScipSalesURI() {
  return inject$1(SCIP_SALES_URI_KEY);
}

var __assign$a = Object.assign;
function interpolate(text, values) {
  return Mustache.render(text, values, {}, {
    escape: (fragment) => fragment,
    tags: ["{", "}"]
  });
}
function t(texts, key, values = {}) {
  const text = texts[key];
  if (!text) {
    return `???${key}???`;
  }
  return interpolate(text, values);
}
function tc(texts, key, count, values = {}) {
  const variantsString = texts[key];
  if (!variantsString) {
    return `???${key}???`;
  }
  let text;
  const variants = variantsString.split("|");
  if (variants.length === 1) {
    text = variants[0];
  } else if (variants.length === 2) {
    text = variants[count === 1 ? 0 : 1];
  } else if (count < 0) {
    text = variants[0];
  } else if (count > variants.length - 1) {
    text = variants[variants.length - 1];
  } else {
    text = variants[count];
  }
  return interpolate(text.trim(), __assign$a(__assign$a({}, values), {count}));
}
function te(texts, key) {
  return Boolean(texts[key]);
}

var ItemRuleOperator;
(function(ItemRuleOperator2) {
  ItemRuleOperator2["Equal"] = "equal";
  ItemRuleOperator2["NotEqual"] = "not_equal";
  ItemRuleOperator2["Greater"] = "greater";
  ItemRuleOperator2["GreaterEqual"] = "greater_equal";
  ItemRuleOperator2["Less"] = "less";
  ItemRuleOperator2["LessEqual"] = "less_equal";
})(ItemRuleOperator || (ItemRuleOperator = {}));

var dist = {};

var functions = {};

Object.defineProperty(functions, "__esModule", { value: true });
class UnreachableCaseError extends Error {
    constructor(value) {
        super(`Unreachable case: ${value}`);
    }
}
functions.UnreachableCaseError = UnreachableCaseError;
function assert(condition, msg = "no additional info provided") {
    if (!condition) {
        throw new Error("Assertion Error: " + msg);
    }
}
functions.assert = assert;
function noop(..._args) { }
functions.noop = noop;

(function (exports) {
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(functions);

}(dist));

function notEmpty(value) {
  return value !== void 0 && value !== null;
}
function deepClone(value) {
  if (value === null || typeof value !== "object") {
    return value;
  }
  return JSON.parse(JSON.stringify(value));
}

const SELECTED_MAIN_MODULES_KEY = "$selectedMainModuleKeys";
const SELECTED_ADD_ON_MODULES_KEY = "$selectedAddOnModuleKeys";
const ERROR_CLASS_NAME = "scip-sales-validation-error";
const DOCUMENT_IDS_KEY = "$documentIds";

function validateValidYear() {
  return this.test({
    message: "Please enter a four-digit year.",
    name: "validYear",
    exclusive: true,
    params: {},
    test: (value) => {
      if (!value) {
        return true;
      }
      const year = getYear(value);
      return year >= 1e3 && year <= 9999;
    }
  });
}

const DAYS_OF_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function validateDayMonth() {
  return this.test({
    message: 'Please enter ${path} as "DD.MM."',
    name: "dayMonth",
    exclusive: true,
    params: {},
    test: (value) => {
      if (!value) {
        return true;
      }
      if (!value.match(/^[0-9]{1,2}\.[0-9]{1,2}\.$/)) {
        return false;
      }
      const [day, month] = value.split(".").map((part) => parseInt(part, 10));
      return month >= 1 && month <= 12 && day >= 1 && day <= DAYS_OF_MONTH[month - 1];
    }
  });
}

Yup.addMethod(Yup.string, "minExcludeEmpty", validateMinExcludeEmpty);
function validateMinExcludeEmpty(min) {
  return this.test({
    message: "${path} must be at least ${min} character(s)",
    name: "min",
    exclusive: true,
    params: {
      min,
      count: min
    },
    test: (value) => {
      if (!value) {
        return true;
      }
      return value.toString().length >= min;
    }
  });
}

function validateMinMainModulesSelected(min) {
  return this.test({
    message: "Please select at least ${min} module(s)",
    name: "minMainModulesSelected",
    exclusive: true,
    params: {
      min,
      count: min
    },
    test: (data, {options: {context}}) => {
      if (!context) {
        throw new Error("no context provided to yupSchema.validateSync");
      }
      if (data.length < min) {
        return false;
      }
      return true;
    }
  });
}
function validateMaxMainModulesSelected(max) {
  return this.test({
    message: "Please select at most ${max} module(s)",
    name: "maxMainModulesSelected",
    exclusive: true,
    params: {
      max,
      count: max
    },
    test: (data, {options: {context}}) => {
      if (!context) {
        throw new Error("no context provided to yupSchema.validateSync");
      }
      if (data.length > max) {
        return false;
      }
      return true;
    }
  });
}
function validateMinAddOnModulesSelected(min) {
  return this.test({
    message: "Please select at least ${min} extra module(s)",
    name: "minAddOnModulesSelected",
    exclusive: true,
    params: {
      min,
      count: min
    },
    test: (data, {options: {context}}) => {
      if (!context) {
        throw new Error("no context provided to yupSchema.validateSync");
      }
      if (data.length < min) {
        return false;
      }
      return true;
    }
  });
}
function validateMaxAddOnModulesSelected(max) {
  return this.test({
    message: "Please select at most ${max} extra module(s)",
    name: "maxAddOnModulesSelected",
    exclusive: true,
    params: {
      max,
      count: max
    },
    test: (data, {options: {context}}) => {
      if (!context) {
        throw new Error("no context provided to yupSchema.validateSync");
      }
      if (data.length > max) {
        return false;
      }
      return true;
    }
  });
}

function relativeDate(offset, isEndOfDay) {
  const today = isEndOfDay ? endOfDay(new Date()) : startOfDay(new Date());
  return (offset !== null && offset !== void 0 ? offset : "").trim().split(/\s+/).reduce((date, expression) => {
    const value = parseInt(expression, 10);
    if (expression.match(/m$/)) {
      return addMonths(date, value);
    }
    if (expression.match(/y$/)) {
      return addYears(date, value);
    }
    return addDays(date, value);
  }, today);
}
function validateRelativeMin(offset) {
  return this.min(relativeDate(offset, false));
}
function validateRelativeMax(offset) {
  return this.max(relativeDate(offset, true));
}

function formatCents(cents) {
  if (typeof cents !== "number" || Number.isNaN(cents)) {
    return "";
  }
  return (cents / 100).toLocaleString("de-DE", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    useGrouping: true
  });
}

function validateMoney() {
  return this.test({
    message: 'Money value ${path} is not valid"',
    name: "validMoney",
    exclusive: true,
    params: {},
    test: (value) => {
      if (!value) {
        return true;
      }
      return Number.isInteger(value.valueCents) && Object.values(CurrencyEnum$1).includes(value.currency);
    }
  });
}
function validateMinMoney(min, currency) {
  return this.test({
    message: "${path} must be at least ${min}",
    name: "minMoney",
    exclusive: true,
    params: {
      min: `${formatCents(min)} ${currency}`,
      minCents: min,
      currency
    },
    test: (value) => {
      if (!value) {
        return true;
      }
      return value.valueCents >= min;
    }
  });
}
function validateMaxMoney(max, currency) {
  return this.test({
    message: "${path} must be at most ${max}",
    name: "maxMoney",
    exclusive: true,
    params: {
      max: `${formatCents(max)} ${currency}`,
      maxCents: max,
      currency
    },
    test: (value) => {
      if (!value) {
        return true;
      }
      return value.valueCents <= max;
    }
  });
}

function validateRequiredZipCity() {
  return this.test({
    message: "${path} is required",
    name: "requiredZipCity",
    exclusive: true,
    params: {},
    test: (value, context) => {
      const error = context.createError();
      error.inner = [];
      if (!value || !value.zip) {
        error.inner.push(context.createError({path: `${context.path}.zip`}));
      }
      if (!value || !value.city) {
        error.inner.push(context.createError({path: `${context.path}.city`}));
      }
      if (error.inner.length) {
        return error;
      }
      return true;
    }
  });
}

function estimateSize(data) {
  return data ? Math.floor((data.length - 3) / 4) * 3 + 1 : 0;
}
function validateUploadFileSize(maxSizeMB) {
  return this.test({
    message: "${path} should not be bigger than ${maxSizeMB} megabyte(s)",
    name: "uploadFileSize",
    exclusive: true,
    params: {
      maxSizeMB,
      count: maxSizeMB
    },
    test: (value) => {
      if (!value) {
        return true;
      }
      return !value.find((file) => estimateSize(file.base64Data) > maxSizeMB * 1024 * 1024);
    }
  });
}

const CODE_LENGTHS = {
  AD: 24,
  AE: 23,
  AL: 28,
  AT: 20,
  AZ: 28,
  BA: 20,
  BE: 16,
  BG: 22,
  BH: 22,
  BR: 29,
  BY: 28,
  CH: 21,
  CR: 21,
  CY: 28,
  CZ: 24,
  DE: 22,
  DK: 18,
  DO: 28,
  EE: 20,
  EG: 29,
  ES: 24,
  FI: 18,
  FO: 18,
  FR: 27,
  GB: 22,
  GE: 22,
  GI: 23,
  GL: 18,
  GR: 27,
  GT: 28,
  HR: 21,
  HU: 28,
  IE: 22,
  IL: 23,
  IQ: 23,
  IS: 26,
  IT: 27,
  JO: 30,
  KW: 30,
  KZ: 20,
  LB: 28,
  LC: 32,
  LI: 21,
  LT: 20,
  LU: 20,
  LV: 21,
  LY: 25,
  MC: 27,
  MD: 24,
  ME: 22,
  MK: 19,
  MR: 27,
  MT: 31,
  MU: 30,
  NL: 18,
  NO: 15,
  PK: 24,
  PL: 28,
  PS: 29,
  PT: 25,
  QA: 29,
  RO: 24,
  RS: 22,
  SA: 24,
  SC: 31,
  SE: 24,
  SI: 19,
  SK: 24,
  SM: 27,
  ST: 25,
  SV: 28,
  TL: 23,
  TN: 24,
  TR: 26,
  UA: 29,
  VA: 22,
  VG: 24,
  XK: 20
};
function validateIban(countryCodes) {
  return this.test({
    message: "IBAN must be valid",
    name: "validIban",
    exclusive: true,
    params: {countryCodes},
    test: (value) => {
      var _a;
      if (!value) {
        return true;
      }
      if (!countryCodes.length) {
        return false;
      }
      if (typeof value !== "string") {
        return false;
      }
      const iban = value.toUpperCase().replace(/[^A-Z0-9]/g, "");
      const code = iban.match(/^([A-Z]{2})(\d{2})([A-Z\d]+)$/);
      const isAllowedCountry = countryCodes.includes(iban.slice(0, 2).toUpperCase());
      if (!isAllowedCountry) {
        return false;
      }
      const selectedCountryLength = (_a = Object.entries(CODE_LENGTHS).find((entry) => entry[0] === (code === null || code === void 0 ? void 0 : code[1]))) === null || _a === void 0 ? void 0 : _a[1];
      if (!code || iban.length !== selectedCountryLength) {
        return false;
      }
      const digits = (code[3] + code[1] + code[2]).replace(/[A-Z]/g, (letter) => (letter.charCodeAt(0) - 55).toString());
      return mod97(digits) === 1;
      function mod97(string) {
        let checksum = parseInt(string.slice(0, 2), 10);
        let fragment;
        for (let offset = 2; offset < string.length; offset += 7) {
          fragment = checksum + string.substring(offset, offset + 7);
          checksum = parseInt(fragment, 10) % 97;
        }
        return checksum;
      }
    }
  });
}

function validateMinGroupElements(min) {
  return this.test({
    message: "${path} requires at least ${min} element(s)",
    name: "minGroupElements",
    exclusive: true,
    params: {
      min,
      count: min
    },
    test: (value) => {
      return Boolean(value && value.length >= min);
    }
  });
}
function validateMaxGroupElements(max) {
  return this.test({
    message: "${path} requires at most ${min} element(s)",
    name: "maxGroupElements",
    exclusive: true,
    params: {
      max,
      count: max
    },
    test: (value) => {
      return !value || value.length <= max;
    }
  });
}

function ageStringToAge(ageString) {
  if (!ageString) {
    return null;
  }
  const numbersArray = ageString.trim().split(" ")[0].match(/\d/g);
  if (!numbersArray) {
    return null;
  }
  return Number(numbersArray.join(""));
}
function validateMinAge(ageString) {
  const minAge = ageStringToAge(ageString);
  return this.test({
    message: "${path} must be at least ${minAge}",
    name: "validMinAge",
    exclusive: true,
    params: {
      minAge
    },
    test: (value) => {
      if (!value || minAge === null) {
        return true;
      }
      if (minAge === 0) {
        const days = differenceInDays(new Date(), value);
        if (days === 0) {
          return isSameDay(new Date(), value);
        }
        return days > 0;
      }
      return differenceInYears(new Date(), value) >= minAge;
    }
  });
}
function validateMaxAge(ageString) {
  const maxAge = ageStringToAge(ageString);
  return this.test({
    message: "${path} must be at most ${maxAge}",
    name: "validMaxAge",
    exclusive: true,
    params: {maxAge},
    test: (value) => {
      if (!value || maxAge === null) {
        return true;
      }
      return differenceInYears(new Date(), value) <= maxAge;
    }
  });
}

function parsePath(path) {
  let dataKey = null;
  let index = null;
  let descendentDataKey = null;
  let propKey = null;
  let rest = path;
  while (true) {
    rest = rest.trim();
    if (rest[0] === ".") {
      rest = rest.substring(1).trim();
    }
    if (rest === "") {
      break;
    }
    const bracedIndexedKeyMatch = rest.match(/^\[['"]([^'"[\]]+)\[(\d+)\]['"]\]/);
    if (bracedIndexedKeyMatch) {
      rest = rest.substring(bracedIndexedKeyMatch[0].length);
      if (!dataKey) {
        dataKey = bracedIndexedKeyMatch[1];
        index = parseInt(bracedIndexedKeyMatch[2], 10);
        continue;
      }
    }
    const bracedKeyMatch = rest.match(/^\[['"]([^'"[\]]+)['"]\]/);
    if (bracedKeyMatch) {
      rest = rest.substring(bracedKeyMatch[0].length);
      if (!dataKey) {
        dataKey = bracedKeyMatch[1];
        continue;
      }
      if (!propKey) {
        propKey = bracedKeyMatch[1];
        continue;
      }
    }
    const indexMatch = rest.match(/^\[(\d+)\]/);
    if (indexMatch) {
      rest = rest.substring(indexMatch[0].length);
      if (dataKey && index === null) {
        index = parseInt(indexMatch[1], 10);
        continue;
      }
    }
    const keyMatch = rest.match(/^([^.[]+)/);
    if (keyMatch) {
      rest = rest.substring(keyMatch[0].length);
      if (!dataKey) {
        dataKey = keyMatch[1];
        continue;
      }
      if (typeof index === "number" && !descendentDataKey) {
        descendentDataKey = keyMatch[1];
        continue;
      }
      if (!propKey) {
        propKey = keyMatch[1];
        continue;
      }
    }
    throw new Error(`Invalid error path ${path}`);
  }
  return {dataKey, index, descendentDataKey, propKey};
}
function renderPath(path) {
  let result = "";
  if (path.dataKey) {
    result += `["${path.dataKey}"]`;
  }
  if (typeof path.index === "number") {
    result += `[${path.index}]`;
  }
  if (path.descendentDataKey) {
    result += `.${path.descendentDataKey}`;
  }
  if (path.propKey) {
    result += `.${path.propKey}`;
  }
  return result;
}
function pathMatches(path, candidates) {
  if (candidates.length === 0) {
    return true;
  }
  return candidates.some((candidate) => {
    const parsedCandidate = parsePath(candidate);
    const matches = parsedCandidate.dataKey === path.dataKey && (!parsedCandidate.descendentDataKey || parsedCandidate.descendentDataKey === path.descendentDataKey) && (!parsedCandidate.propKey || parsedCandidate.propKey === path.propKey);
    return matches;
  });
}

var FormMode;
(function(FormMode2) {
  FormMode2["default"] = "default";
  FormMode2["formBuilder"] = "formBuilder";
})(FormMode || (FormMode = {}));
const getFormMode = () => {
  const urlParams = new URLSearchParams(window.location.search);
  const formBuilderParam = urlParams.get("application-form-builder");
  if (formBuilderParam === "true") {
    return FormMode.formBuilder;
  }
  return FormMode.default;
};

var __assign$9 = Object.assign;
Yup.addMethod(Yup.string, "minExcludeEmpty", validateMinExcludeEmpty);
Yup.addMethod(Yup.date, "relativeMin", validateRelativeMin);
Yup.addMethod(Yup.date, "relativeMax", validateRelativeMax);
Yup.addMethod(Yup.date, "validMinAge", validateMinAge);
Yup.addMethod(Yup.date, "validMaxAge", validateMaxAge);
Yup.addMethod(Yup.date, "validYear", validateValidYear);
Yup.addMethod(Yup.string, "dayMonth", validateDayMonth);
Yup.addMethod(Yup.array, "maxMainModulesSelected", validateMaxMainModulesSelected);
Yup.addMethod(Yup.array, "minMainModulesSelected", validateMinMainModulesSelected);
Yup.addMethod(Yup.array, "maxAddOnModulesSelected", validateMaxAddOnModulesSelected);
Yup.addMethod(Yup.array, "minAddOnModulesSelected", validateMinAddOnModulesSelected);
Yup.addMethod(Yup.object, "validMoney", validateMoney);
Yup.addMethod(Yup.object, "minMoney", validateMinMoney);
Yup.addMethod(Yup.object, "maxMoney", validateMaxMoney);
Yup.addMethod(Yup.object, "requiredZipCity", validateRequiredZipCity);
Yup.addMethod(Yup.array, "uploadFileSize", validateUploadFileSize);
Yup.addMethod(Yup.string, "validateIban", validateIban);
Yup.addMethod(Yup.array, "minGroupElements", validateMinGroupElements);
Yup.addMethod(Yup.array, "maxGroupElements", validateMaxGroupElements);
const GLOBAL_ERROR_KEY = "$global";
const typeRules = {
  GroupField: [["yup.array"], ["yup.required"], ["yup.of", [["yup.object"], ["yup.required"]]]],
  TextField: [["yup.string"]],
  TextAreaField: [["yup.string"]],
  NumberField: [["yup.number"]],
  BooleanField: [["yup.boolean"]],
  DateField: [["yup.date"], ["yup.validYear"]],
  SelectField: [["yup.string"]],
  RadioGroupField: [["yup.string"]],
  MoneyField: [["yup.object"], ["yup.nullable"], ["yup.validMoney"]],
  ZipCityField: [
    ["yup.object"],
    [
      "yup.shape",
      {
        zip: [["yup.string"]],
        city: [["yup.string"]]
      }
    ]
  ],
  LocationsField: [
    ["yup.array"],
    ["yup.required"],
    [
      "yup.of",
      [
        ["yup.object"],
        ["yup.required"],
        [
          "yup.shape",
          {
            zip: [["yup.string"], ["yup.required"]],
            city: [["yup.string"], ["yup.required"]],
            country: [["yup.string"], ["yup.required"]],
            houseNumber: [["yup.string"]],
            street: [["yup.string"], ["yup.required"]]
          }
        ]
      ]
    ]
  ],
  UploadField: [
    ["yup.array"],
    [
      "yup.of",
      [
        ["yup.object"],
        ["yup.required"],
        [
          "yup.shape",
          {
            fileName: [["yup.string"], ["yup.required"]],
            mimeType: [["yup.string"], ["yup.required"]],
            base64Data: [["yup.string"], ["yup.required"]]
          }
        ]
      ]
    ]
  ],
  IbanField: [["yup.string"]],
  ModuleSelectionField: [["yup.array"]]
};
function convertRegexpRule(rule) {
  if (rule[0] === "yup.matches") {
    return ["yup.matches", new RegExp(rule[1], "u"), rule[2]];
  }
  return rule;
}
function createYupSchema(context, items, additionalValidation, paths = []) {
  const schema = [
    [
      "yup.object",
      Object.fromEntries(items.filter(shouldValidate).filter((item) => isItemVisible(item, context)).flatMap((item) => {
        if (item.__typename === "GroupField") {
          return createYupSchemaForGroupField(item, paths, context);
        }
        if (item.__typename === "DownloadItem") {
          return createYupSchemaForDownloadItem(item);
        }
        return createYupSchemaForField(item);
      }))
    ],
    ...additionalValidation
  ];
  return transformAll(schema, Yup);
}
function createYupSchemaForField(field) {
  const {__typename, validation} = field;
  const typeRule = typeRules[__typename];
  const validationRules = (validation || []).map(convertRegexpRule);
  return [[field.dataKey, [...typeRule, ...validationRules]]];
}
function createYupSchemaForDownloadItem(item) {
  const typeRule = typeRules.BooleanField;
  const validationRules = [["yup.required"], ["yup.oneOf", [true]]];
  const {confirmationAttributeDataKey} = item;
  if (!confirmationAttributeDataKey) {
    return [];
  }
  return [[confirmationAttributeDataKey, [...typeRule, ...validationRules]]];
}
function createYupSchemaForGroupField(group, paths, context) {
  const typeRule = [
    ["yup.array"],
    ["yup.required"],
    ["yup.of", [["yup.object"], ["yup.required"]]]
  ];
  const validationRules = (group.validation || []).map(convertRegexpRule);
  const fieldData = context.data[group.dataKey];
  const elementRules = fieldData.map((elementData, elementIndex) => {
    var _a;
    return [
      `${group.dataKey}[${elementIndex}]`,
      [
        ["yup.object"],
        [
          "yup.shape",
          Object.fromEntries(((_a = group.descendents) !== null && _a !== void 0 ? _a : []).filter((descendent) => isDescendentFieldVisible(group, descendent, context, elementData) && pathMatches({dataKey: group.dataKey, descendentDataKey: descendent.dataKey}, paths)).map((descendent) => {
            const descendentTypeRule = typeRules[descendent.__typename];
            const descendentValidationRules = (descendent.validation || []).map(convertRegexpRule);
            return [descendent.dataKey, [...descendentTypeRule, ...descendentValidationRules]];
          }))
        ]
      ]
    ];
  });
  return [[group.dataKey, [...typeRule, ...validationRules]]].concat(elementRules);
}
function prepareData(data) {
  const result = {};
  Object.keys(data).forEach((key) => {
    const value = data[key];
    if (value === null) {
      result[key] = void 0;
    } else if (Array.isArray(value)) {
      result[key] = value.map(prepareData);
      value.forEach((element, index) => {
        result[`${key}[${index}]`] = prepareData(element);
      });
    } else {
      result[key] = value;
    }
  });
  return result;
}
const useFormValidation = (args) => {
  const {data, schema, serverErrors, tariff, formMode} = args;
  const errors = reactive$1(createEmptyErrors(schema));
  const isValid = ref$1(false);
  const resetErrors = (paths) => {
    paths.forEach((path) => {
      setError(errors, parsePath(path), null);
    });
  };
  const setValidationErrors = (validationErrors) => {
    validationErrors.forEach((yupError) => {
      const parsedPath = parsePath(yupError.path);
      const {dataKey, index, descendentDataKey, propKey} = parsedPath;
      const error = {
        type: yupError.type,
        message: yupError.message,
        keys: joinKeys(dataKey !== null && dataKey !== void 0 ? dataKey : GLOBAL_ERROR_KEY, descendentDataKey, propKey),
        dataKey: dataKey !== null && dataKey !== void 0 ? dataKey : GLOBAL_ERROR_KEY,
        index: typeof index === "number" ? index : null,
        descendentDataKey: descendentDataKey !== null && descendentDataKey !== void 0 ? descendentDataKey : null,
        propKey: propKey !== null && propKey !== void 0 ? propKey : null,
        params: yupError.params
      };
      setError(errors, {dataKey, index, descendentDataKey, propKey}, error);
    });
  };
  const validate = (yupSchema, fields, paths = [], ignoredValidations = [], setErrors = true) => {
    let hasValidationError = false;
    let hasServerError = false;
    fields.forEach((field) => {
      const serverError = serverErrors.value.find((error) => `${error.moduleKey}.${error.attributeKey}` === field.dataKey);
      if (!serverError) {
        return;
      }
      hasServerError = true;
      errors[field.dataKey] = {
        type: "serverInvalid",
        message: `Field "${field.label}" is not valid`,
        keys: field.dataKey,
        dataKey: field.dataKey,
        index: null,
        descendentDataKey: null,
        propKey: null,
        params: __assign$9({}, serverError)
      };
    });
    try {
      yupSchema.validateSync(prepareData(data), {abortEarly: false, context: {schema}});
    } catch ({inner = [], message}) {
      hasValidationError = true;
      if (setErrors) {
        const validationErrors = inner.filter((error) => error.type && !ignoredValidations.includes(error.type)).filter((error) => pathMatches(parsePath(error.path), paths));
        setValidationErrors(validationErrors);
      }
    }
    isValid.value = !hasValidationError && !hasServerError;
    return isValid.value;
  };
  const validateFields = (paths, ignoredValidations = []) => {
    const dataKeys = paths.map((path) => parsePath(path).dataKey);
    const fields = Object.values(schema.items).filter(isField).filter((field) => dataKeys.includes(field.dataKey));
    resetErrors(paths);
    const context = {schema, data, tariff: tariff.value};
    const yupSchema = createYupSchema(context, fields, [], paths);
    validate(yupSchema, fields, paths, ignoredValidations);
  };
  const validateStep = (stepId, setErrors) => {
    if (formMode === FormMode.formBuilder) {
      return true;
    }
    const steps = Object.entries(schema.steps).filter(([id]) => stepId === void 0 || id === stepId).map(([_id, step]) => step);
    const stepValidations = steps.flatMap((step) => (step.validation || []).map(convertRegexpRule));
    const itemIds = steps.flatMap((step) => {
      return step.itemIds.flatMap((itemId) => {
        const item = schema.items[itemId];
        if (item.__typename === "SummaryItem") {
          return item.editableItemIds;
        }
        if (item.__typename === "RowItem") {
          return item.itemIds;
        }
        if (item.__typename === "ModuleSelectionField") {
          const mainModuleKeys = getModuleKeys(data, false);
          const addOnModuleKeys = getModuleKeys(data, true);
          return item.modules.filter((module) => [...mainModuleKeys, ...addOnModuleKeys].includes(module.key)).flatMap((module) => module.itemIds).concat(itemId);
        }
        return itemId;
      });
    });
    const fields = Object.values(schema.items).filter((item) => itemIds.includes(item.id)).filter(isField);
    resetErrors([GLOBAL_ERROR_KEY, ...fields.map((field) => `["${field.dataKey}"]`)]);
    const context = {schema, data, tariff: tariff.value};
    const yupSchema = createYupSchema(context, fields, stepValidations);
    return validate(yupSchema, fields, [], [], setErrors);
  };
  const validateAll = () => {
    const items = Object.values(schema.items).filter(shouldValidate);
    const paths = getFieldErrorPaths(items);
    resetErrors(paths);
    const steps = Object.values(schema.steps);
    const stepValidations = steps.flatMap((step) => (step.validation || []).map(convertRegexpRule));
    const context = {schema, data, tariff: tariff.value};
    const yupSchema = createYupSchema(context, items, stepValidations);
    const fields = Object.values(schema.items).filter(isField);
    return validate(yupSchema, fields);
  };
  const getFieldErrorPaths = (items) => {
    const paths = [GLOBAL_ERROR_KEY];
    items.forEach((item) => {
      if (isField(item)) {
        paths.push(`["${item.dataKey}"]`);
      }
      if (item.__typename === "DownloadItem" && !!item.confirmationAttributeDataKey) {
        paths.push(`["${item.confirmationAttributeDataKey}"]`);
      }
    });
    return paths;
  };
  const validateSaveRequiredFields = () => {
    const fields = Object.values(schema.items).filter(isField);
    resetErrors([GLOBAL_ERROR_KEY, ...fields.map((item) => `["${item.dataKey}"]`)]);
    const steps = Object.values(schema.steps);
    const stepValidations = steps.flatMap((step) => (step.validation || []).map(convertRegexpRule));
    const context = {schema, data, tariff: tariff.value};
    const saveRequiredFields = fields.filter((field) => field.requiredForSaving).map((field) => __assign$9(__assign$9({}, field), {
      validation: field.validation.find((rule) => rule[0] === "yup.required") ? field.validation : [...field.validation, ["yup.required"]]
    }));
    const yupSchema = createYupSchema(context, saveRequiredFields, stepValidations);
    return validate(yupSchema, fields);
  };
  watch$1(() => serverErrors.value, (newServerErrors, oldServerErrors) => {
    validateFields([...oldServerErrors, ...newServerErrors].filter((error) => error.moduleKey && error.attributeKey).map((error) => `["${error.moduleKey}.${error.attributeKey}"]`));
  });
  return {
    data,
    errors,
    isValid,
    validateStep,
    validateAll,
    validateFields,
    validateSaveRequiredFields
  };
};
function setError(errors, parsedPath, error) {
  const {dataKey, index, descendentDataKey, propKey} = parsedPath;
  if (!dataKey || dataKey === GLOBAL_ERROR_KEY) {
    errors[GLOBAL_ERROR_KEY] = error;
    return;
  }
  let newValue = deepClone(errors[dataKey]);
  if (typeof index === "number" && descendentDataKey) {
    if (!Array.isArray(newValue)) {
      newValue = [];
    }
    if (propKey) {
      const elementsErrors = newValue;
      if (!isTrueObject(elementsErrors[index])) {
        elementsErrors[index] = {};
      }
      if (!isTrueObject(elementsErrors[index][descendentDataKey])) {
        elementsErrors[index][descendentDataKey] = {};
      }
      elementsErrors[index][descendentDataKey][propKey] = error;
    } else {
      const elementsErrors = newValue;
      if (!isTrueObject(elementsErrors[index])) {
        elementsErrors[index] = {};
      }
      elementsErrors[index][descendentDataKey] = error;
    }
  } else if (propKey) {
    if (!isTrueObject(newValue)) {
      newValue = {};
    }
    newValue[propKey] = error;
  } else {
    newValue = error;
  }
  errors[dataKey] = newValue;
}
function isTrueObject(value) {
  return value !== null && value !== void 0 && !Array.isArray(value) && typeof value === "object" && !(value instanceof Date);
}
function joinKeys(dataKey, descendentDataKey, propKey) {
  const result = [dataKey];
  if (descendentDataKey) {
    result.push(descendentDataKey);
  }
  if (propKey) {
    result.push(propKey);
  }
  return result.join(".");
}

var __assign$8 = Object.assign;
const formatRelativeDate = () => (text) => {
  const [dateOffset, pattern] = (text || "").split(" ");
  if (!dateOffset || !pattern) {
    return "";
  }
  const date = relativeDate(dateOffset, false);
  return format(date, pattern.trim());
};
const normalizeSchema = (schema) => {
  const {items, steps, id, product, options, globalTexts, __scipSalesVersion} = schema;
  const normalizedSchema = {
    id,
    __scipSalesVersion,
    product,
    items: Object.fromEntries(items.map((item) => [item.id, item])),
    stepIds: steps.map((step) => step.id),
    steps: Object.fromEntries(steps.map((step) => {
      var _a;
      return [
        step.id,
        {
          id: step.id,
          title: step.title,
          subtitle: step.subtitle,
          relativePath: step.relativePath,
          itemIds: step.itemIds,
          validation: (_a = step.validation) !== null && _a !== void 0 ? _a : [],
          showTariff: step.showTariff,
          navigateOnInput: step.navigateOnInput
        }
      ];
    })),
    initialData: Object.fromEntries(schema.initialData.map((initialValue) => {
      const item = items.find((candidate) => "dataKey" in candidate && candidate.dataKey === initialValue.id);
      const value = typeof initialValue.value === "string" ? Mustache.render(initialValue.value, {
        formatRelativeDate
      }, {}, ["${", "}"]) : initialValue.value;
      if ((item === null || item === void 0 ? void 0 : item.__typename) === "DateField" && typeof initialValue.value === "string") {
        return [initialValue.id, parseISO(value)];
      }
      return [initialValue.id, value];
    })),
    options,
    globalTexts
  };
  return normalizedSchema;
};
function getFieldsForData(schema, dataKey) {
  const [moduleKey, attributeKey] = dataKey.split(".");
  return Object.values(schema.items).filter((item) => {
    var _a, _b, _c;
    if (!isField(item)) {
      return false;
    }
    return ((_a = item.source) === null || _a === void 0 ? void 0 : _a.kind) === "attribute" && ((_b = item.source) === null || _b === void 0 ? void 0 : _b.moduleKey) === moduleKey && ((_c = item.source) === null || _c === void 0 ? void 0 : _c.attributeKey) === attributeKey;
  });
}
function getModuleKeys(data, addOn) {
  const moduleKeys = data[addOn ? SELECTED_ADD_ON_MODULES_KEY : SELECTED_MAIN_MODULES_KEY];
  return moduleKeys || [];
}
const createEmptyErrors = ({items}) => {
  const emptyErrors = {[GLOBAL_ERROR_KEY]: null};
  Object.values(items).filter(shouldValidate).forEach((item) => {
    const errorKey = getErrorKeyFromItem(item);
    if (errorKey) {
      emptyErrors[errorKey] = null;
    }
  });
  return emptyErrors;
};
function getErrorKeyFromItem(item) {
  if (item.__typename === "DownloadItem") {
    return item.confirmationAttributeDataKey;
  }
  return item.dataKey;
}
function formatDate(value) {
  return value instanceof Date ? format(value, "yyyy-MM-dd") : value;
}
function formatValue(value, item) {
  if ((item === null || item === void 0 ? void 0 : item.__typename) === "GroupField") {
    return value.map((element) => Object.fromEntries(Object.entries(element).map(([key, elementFieldValue]) => [
      key,
      formatDate(elementFieldValue)
    ])));
  }
  return formatDate(value);
}
function formatToApplicationDataInput(schema, data, includeUploads) {
  return Object.entries(data).map(([dataKey, value]) => {
    if ([SELECTED_MAIN_MODULES_KEY, SELECTED_ADD_ON_MODULES_KEY].includes(dataKey)) {
      return {
        dataKey,
        source: {kind: SourceKind.ModuleSelection, moduleKey: null, attributeKey: null},
        value
      };
    }
    if (DOCUMENT_IDS_KEY === dataKey) {
      return {
        dataKey,
        source: {kind: SourceKind.DocumentIds, moduleKey: null, attributeKey: null},
        value
      };
    }
    const item = getFieldsForData(schema, dataKey)[0];
    if (!item) {
      const [moduleKey, attributeKey] = dataKey.split(".");
      if (value === null || value === "") {
        return null;
      }
      return {
        dataKey,
        source: {
          kind: SourceKind.Attribute,
          moduleKey,
          attributeKey
        },
        value: formatValue(value)
      };
    }
    if (!isField(item)) {
      return null;
    }
    if (!includeUploads && item.__typename === "UploadField") {
      return null;
    }
    if (value === void 0 || value === null || Array.isArray(value) && value.length === 0) {
      return null;
    }
    return {
      dataKey,
      source: {
        kind: item.source.kind,
        moduleKey: item.source.moduleKey,
        attributeKey: item.source.attributeKey
      },
      value: formatValue(value, item)
    };
  }).filter(notEmpty);
}
function formatMoney(money) {
  if (!money) {
    return "";
  }
  const {valueCents, currency} = money;
  return new Intl.NumberFormat("de-DE", {style: "currency", currency}).format(valueCents / 100);
}
function getObjectValue(keys, obj) {
  if (keys.length === 0) {
    return obj;
  }
  const firstKey = keys[0];
  if (obj[firstKey]) {
    keys.splice(0, 1);
    return getObjectValue(keys, obj[firstKey]);
  }
  return null;
}
function saveDataLocally(form, uploadDataKeys) {
  if (form) {
    localStorage.setItem("scipSales.applicationForm", JSON.stringify(__assign$8(__assign$8({}, form), {
      data: Object.fromEntries(Object.entries(form.data).filter(([dataKey]) => !uploadDataKeys || !uploadDataKeys.includes(dataKey)))
    })));
  } else {
    localStorage.removeItem("scipSales.applicationForm");
  }
}
function loadDataLocally() {
  try {
    const formDataString = localStorage.getItem("scipSales.applicationForm");
    if (!formDataString) {
      return null;
    }
    const formData = JSON.parse(formDataString);
    return __assign$8(__assign$8({}, formData), {
      data: parseObjectDates(formData.data)
    });
  } catch (error) {
    return null;
  }
}
function parseObjectDates(object) {
  return Object.fromEntries(Object.entries(object).map(([key, value]) => {
    if (typeof value === "string" && value.match(/[0-9]{4}-[0-9]{2}-[0-9]{2}T[0-9]{2}:[0-9]{2}:[0-9]{2}.[0-9]{3}Z/)) {
      return [key, new Date(value)];
    }
    if (value && typeof value === "object" && !Array.isArray(value)) {
      return [key, parseObjectDates(value)];
    }
    return [key, value];
  }));
}

function useVisibility({schema, data, tariff, formMode}) {
  const getVisibleItemsByStep = (currentData, currentTariff) => {
    const result = Object.fromEntries(schema.value.stepIds.map((stepId) => [
      stepId,
      schema.value.steps[stepId].itemIds.filter((id) => {
        const item = schema.value.items[id];
        if (!item) {
          throw new Error(`Cannot find item ID ${id}, known IDs: ${Object.keys(schema.value.items)}`);
        }
        return isItemVisible(item, {
          schema: schema.value,
          data: currentData,
          tariff: currentTariff
        });
      })
    ]));
    return result;
  };
  const visibleItemsByStep = ref$1(getVisibleItemsByStep(data, tariff.value));
  watch$1(data, (newData) => {
    visibleItemsByStep.value = getVisibleItemsByStep(newData, tariff.value);
  });
  watch$1(tariff, (newTariff) => {
    visibleItemsByStep.value = getVisibleItemsByStep(data, newTariff);
  });
  watch$1(schema, () => {
    visibleItemsByStep.value = getVisibleItemsByStep(data, tariff.value);
  });
  const visibleStepIds = computed$1(() => {
    if (formMode === FormMode.formBuilder) {
      return schema.value.stepIds;
    }
    return schema.value.stepIds.filter((stepId) => visibleItemsByStep.value[stepId].length > 0);
  });
  return {
    visibleStepIds,
    visibleSteps: computed$1(() => visibleStepIds.value.map((stepId) => schema.value.steps[stepId])),
    visibleItemsByStep
  };
}
function filterGroupElementByVisibility(elementData, groups, context) {
  const result = {};
  groups.forEach((group) => {
    group.descendents.forEach((descendent) => {
      if (isDescendentFieldVisible(group, descendent, context, elementData)) {
        result[descendent.dataKey] = elementData[descendent.dataKey];
      }
    });
  });
  return result;
}
function isItemVisible(item, context) {
  if (item.__typename === "ModuleSelectionField" && item.modules.length === 0) {
    return false;
  }
  if (!item.visibility || item.visibility.length === 0) {
    return true;
  }
  return item.visibility.some((ruleConjunction) => ruleConjunction.every((rule) => isRuleMatching(rule, context)));
}
function isModuleVisible(module, context) {
  if (!module.visibility || module.visibility.length === 0) {
    return true;
  }
  return module.visibility.some((ruleConjunction) => ruleConjunction.every((rule) => isRuleMatching(rule, context)));
}
function isDescendentFieldVisible(groupField, descendentField, context, elementData) {
  if (!descendentField.visibility || descendentField.visibility.length === 0) {
    return true;
  }
  return descendentField.visibility.some((ruleConjunction) => ruleConjunction.every((rule) => {
    if (rule.__typename === "AttributeItemRule") {
      const referencedItem = groupField.descendents.find((candidate) => candidate.dataKey === rule.attributeKey);
      const descendentData = referencedItem && referencedItem.__typename !== "GroupField" && isField(referencedItem) && isDescendentFieldVisible(groupField, referencedItem, context, elementData) ? elementData[referencedItem.dataKey] : null;
      return isRuleValueMatching(descendentData, rule.operator, rule.value);
    }
    if (rule.__typename === "FieldItemRule") {
      const referencedItem = groupField.descendents.find((candidate) => candidate.id === rule.itemId);
      const descendentData = referencedItem && referencedItem.__typename !== "GroupField" && isField(referencedItem) && isDescendentFieldVisible(groupField, referencedItem, context, elementData) ? elementData[referencedItem.dataKey] : null;
      return isRuleValueMatching(descendentData, rule.operator, rule.value);
    }
    if (rule.__typename === "ModuleSelectionItemRule") {
      return [...getModuleKeys(context.data, false), ...getModuleKeys(context.data, true)].includes(rule.moduleKey) === rule.selected;
    }
    return isRuleMatching(rule, context);
  }));
}
function getReferencedValue(referencedItem, data) {
  var _a;
  const value = data[referencedItem.dataKey];
  if ((referencedItem === null || referencedItem === void 0 ? void 0 : referencedItem.__typename) === "MoneyField") {
    return (_a = value) === null || _a === void 0 ? void 0 : _a.valueCents;
  }
  if ((referencedItem === null || referencedItem === void 0 ? void 0 : referencedItem.__typename) === "DateField") {
    const today = new Date();
    if (!value) {
      return null;
    }
    const date = value instanceof Date ? value : new Date(value);
    if (!isValid) {
      return null;
    }
    const age = differenceInYears(today, date);
    return age;
  }
  return value;
}
function isRuleMatching(rule, context) {
  var _a, _b, _c, _d, _e, _f;
  const {schema, data, tariff} = context;
  if (!rule.__typename) {
    throw new Error("Rule __typename is missing");
  }
  switch (rule.__typename) {
    case "AttributeItemRule": {
      const referencedField = Object.values(schema.items).find((item) => isField(item) && item.dataKey === `${rule.moduleKey}.${rule.attributeKey}`);
      const referencedValue = isField(referencedField) && isItemVisible(referencedField, context) ? getReferencedValue(referencedField, data) : null;
      return isRuleValueMatching(referencedValue, rule.operator, rule.value);
    }
    case "FieldItemRule": {
      const referencedItem = schema.items[rule.itemId];
      const referencedValue = isField(referencedItem) && isItemVisible(referencedItem, context) ? getReferencedValue(referencedItem, data) : null;
      return isRuleValueMatching(referencedValue, rule.operator, rule.value);
    }
    case "ModuleSelectionItemRule": {
      return [...getModuleKeys(data, false), ...getModuleKeys(data, true)].includes(rule.moduleKey) === rule.selected;
    }
    case "PremiumItemRule": {
      let referencedValue;
      if (rule.premiumKey) {
        const premium = (_b = (_a = tariff === null || tariff === void 0 ? void 0 : tariff.premia) === null || _a === void 0 ? void 0 : _a.find((candidate) => candidate.moduleKey === rule.premiumKey)) !== null && _b !== void 0 ? _b : null;
        referencedValue = (_c = premium === null || premium === void 0 ? void 0 : premium.premium) !== null && _c !== void 0 ? _c : null;
      } else {
        referencedValue = (_d = tariff === null || tariff === void 0 ? void 0 : tariff.totalPremium) !== null && _d !== void 0 ? _d : null;
      }
      return isRuleValueMatching(referencedValue, rule.operator, rule.premiumValue);
    }
    case "ComputedValueItemRule": {
      const computedValue = (_f = (_e = tariff === null || tariff === void 0 ? void 0 : tariff.computedValues) === null || _e === void 0 ? void 0 : _e[rule.computedValueKey]) !== null && _f !== void 0 ? _f : null;
      return isRuleValueMatching(computedValue, rule.operator, rule.value);
    }
    default:
      throw new dist.UnreachableCaseError(rule);
  }
}
function isRuleValueMatching(dataValue, operator, ruleValue) {
  const isDataNullish = dataValue === null || dataValue === void 0;
  const isRuleNullish = ruleValue === null || ruleValue === void 0;
  if (isDataNullish && isRuleNullish) {
    return operator === ItemRuleOperator.Equal;
  }
  const isDataBoolean = typeof dataValue === "boolean";
  const isDataString = typeof dataValue === "string";
  const isRuleBoolean = typeof ruleValue === "boolean";
  const isRuleString = typeof ruleValue === "string";
  if (isDataBoolean && isRuleBoolean || isDataString && isRuleString) {
    return operator === ItemRuleOperator.Equal ? dataValue === ruleValue : dataValue !== ruleValue;
  }
  if (isNumber(dataValue) && isNumber(ruleValue)) {
    return compareNumber(dataValue, operator, ruleValue);
  }
  if (Array.isArray(dataValue) && Array.isArray(ruleValue)) {
    const arraysEqual = dataValue.length === ruleValue.length ? dataValue.every((ruleElement) => ruleValue.includes(ruleElement)) : false;
    return operator === ItemRuleOperator.Equal ? arraysEqual : !arraysEqual;
  }
  const isDataObject = typeof dataValue === "object" && dataValue !== null;
  const isRuleObject = typeof ruleValue === "object" && ruleValue !== null;
  if (isDataObject && isRuleObject) {
    const isDataMoney = typeof dataValue.valueCents === "number" && dataValue.currency;
    const isRuleMoney = typeof ruleValue.valueCents === "number" && ruleValue.currency;
    if (isDataMoney && isRuleMoney) {
      if (dataValue.currency !== ruleValue.currency) {
        return operator === ItemRuleOperator.NotEqual;
      }
      return compareNumber(dataValue.valueCents, operator, ruleValue.valueCents);
    }
    const objectsEquals = deepEqual(dataValue, ruleValue, {strict: true});
    return operator === ItemRuleOperator.Equal ? objectsEquals : !objectsEquals;
  }
  return operator === ItemRuleOperator.NotEqual;
}
function deselectInvisibleModules(formContext) {
  const modulesToDeselect = Object.values(formContext.schema.items).filter((item) => item.__typename === "ModuleSelectionField").flatMap((field) => field.modules.filter((module) => formContext.selectedModules.includes(module.key) && !isModuleVisible(module, formContext)).map((module) => ({
    key: module.key,
    addOn: module.addOn,
    selected: false
  })));
  if (modulesToDeselect.length) {
    formContext.updateSelectedModules(modulesToDeselect);
  }
}
function compareNumber(dataValue, operator, ruleValue) {
  switch (operator) {
    case ItemRuleOperator.Equal:
      return dataValue === ruleValue;
    case ItemRuleOperator.NotEqual:
      return dataValue !== ruleValue;
    case ItemRuleOperator.Greater:
      return dataValue > ruleValue;
    case ItemRuleOperator.GreaterEqual:
      return dataValue >= ruleValue;
    case ItemRuleOperator.Less:
      return dataValue < ruleValue;
    case ItemRuleOperator.LessEqual:
      return dataValue <= ruleValue;
    default:
      throw new dist.UnreachableCaseError(operator);
  }
}
function isNumber(value) {
  return typeof value === "number";
}

var __assign$7 = Object.assign;
const useFormBuilderEvents = ({updateSchema, navigateToStep, changeSummaryMode, restrictInteractivity}) => {
  if (getFormMode() !== FormMode.formBuilder) {
    return;
  }
  const scipSalesURI = injectScipSalesURI();
  const scipSalesOrigin = scipSalesURI ? new URL(scipSalesURI, window.location.href).origin : null;
  const onMessage = ({data, origin}) => {
    if (!scipSalesOrigin || origin !== scipSalesOrigin) {
      return;
    }
    switch (data.type) {
      case "updateSchema":
        if (updateSchema) {
          updateSchema(data.newSchema);
        }
        break;
      case "navigateToStep":
        if (navigateToStep) {
          navigateToStep(data.stepKey);
        }
        break;
      case "changeSummaryMode":
        if (changeSummaryMode) {
          changeSummaryMode(data);
        }
        break;
      case "restrictInteractivity":
        if (restrictInteractivity) {
          restrictInteractivity(data);
        }
        break;
      default:
        console.warn(`unsupported event: "${data.type}"`);
    }
  };
  const sendEvent = (event) => {
    if (!scipSalesOrigin) {
      return;
    }
    window.parent.postMessage(event, scipSalesOrigin);
  };
  window.addEventListener("message", onMessage);
  sendEvent({type: "form-ready", customFormBuilderParamDefinitions});
  onUnmounted$1(() => {
    window.removeEventListener("message", onMessage);
  });
};
const customFormBuilderParamDefinitions = {};
const defineCustomFormBuilderParams = (typeKey, paramDefinitions) => {
  customFormBuilderParamDefinitions[typeKey] = Object.entries(paramDefinitions).map(([key, paramDefinition]) => __assign$7(__assign$7({}, paramDefinition), {key}));
  const getCustomParameter = (objectWithCustomParams, customParamKey) => {
    var _a;
    return (_a = objectWithCustomParams.customParameters.find(({key}) => key === customParamKey)) === null || _a === void 0 ? void 0 : _a.value;
  };
  const useCustomParameters = (objectWithCustomParams) => {
    return Object.fromEntries(Object.entries(paramDefinitions).map(([key]) => [
      key,
      computed$1(() => {
        var _a;
        return (_a = objectWithCustomParams.value.customParameters.find((customParam) => customParam.key === key)) === null || _a === void 0 ? void 0 : _a.value;
      })
    ]));
  };
  return {useCustomParameters, getCustomParameter};
};

/*!
 * vue-client-only v0.0.0-semantic-release
 * (c) 2021-present egoist <0x142857@gmail.com>
 * Released under the MIT License.
 */

var index = {
  name: 'ClientOnly',
  functional: true,
  props: {
    placeholder: String,
    placeholderTag: {
      type: String,
      default: 'div'
    }
  },
  render: function render(h, ref) {
    var parent = ref.parent;
    var slots = ref.slots;
    var props = ref.props;

    var ref$1 = slots();
    var defaultSlot = ref$1.default; if ( defaultSlot === void 0 ) defaultSlot = [];
    var placeholderSlot = ref$1.placeholder;

    if (parent._isMounted) {
      return defaultSlot
    }

    parent.$once('hook:mounted', function () {
      parent.$forceUpdate();
    });

    if (props.placeholderTag && (props.placeholder || placeholderSlot)) {
      return h(
        props.placeholderTag,
        {
          class: ['client-only-placeholder']
        },
        props.placeholder || placeholderSlot
      )
    }

    // Return a placeholder element for each child in the default slot
    // Or if no children return a single placeholder
    return defaultSlot.length > 0 ? defaultSlot.map(function () { return h(false); }) : h(false)
  }
};

var vueClientOnly_common = index;

const key = Symbol("globalEmit");
const provideGlobalEmit = (emit) => {
  provide(key, emit);
};
const useGlobalEmit = () => {
  const globalEmit = inject$1(key);
  if (!globalEmit)
    throw new Error("globalEmit should be provided");
  return globalEmit;
};

var __async$4 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const useCheckForDenial = ({data, schema, shouldCheckDeny, channel}) => {
  const globalEmit = useGlobalEmit();
  const {resolveClient} = useApolloClient();
  const checkForDenial = () => __async$4(undefined, null, function* () {
    if (!shouldCheckDeny.value) {
      return;
    }
    const {productKey, variantKey, versionNumber} = schema.value.product;
    const result = yield resolveClient().query({
      query: ApplicationOutcomeDocument,
      variables: {
        input: {
          data: formatToApplicationDataInput(schema.value, data, false),
          product: {
            productKey,
            variantKey,
            versionNumber
          },
          channel: channel.value
        }
      }
    });
    const {applicationOutcome} = result.data;
    if (applicationOutcome.__typename === "OutcomeResults" && applicationOutcome.outcomeType === OutcomeTypeEnum.Deny) {
      globalEmit("deny");
    }
  });
  return checkForDenial;
};

const FormContextKey = Symbol("form-context");
const provideFormContext = (context) => {
  provide(FormContextKey, context);
};
const useFormContext = () => {
  const formContext = inject$1(FormContextKey);
  if (!formContext) {
    throw new Error("no formContext provided use provideFormContext()");
  }
  return formContext;
};

var __async$3 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const useFormSteps = ({currentStepId, initialStepId, stepIds, validateStep, checkForDenial, getFormContext, navigationEnabled = true}) => {
  const globalEmit = useGlobalEmit();
  const goToStep = (stepId) => {
    globalEmit("goToStep", {stepId, formContext: getFormContext()});
  };
  const initialStepIdOrFirst = initialStepId !== null && initialStepId !== void 0 ? initialStepId : stepIds.value[0];
  if (!currentStepId.value) {
    Vue.nextTick(() => goToStep(initialStepIdOrFirst));
  }
  const innerCurrentStepId = computed$1(() => {
    return currentStepId.value || initialStepIdOrFirst;
  });
  const onNext = () => __async$3(undefined, null, function* () {
    if (!navigationEnabled) {
      return;
    }
    if (validateStep(innerCurrentStepId.value)) {
      checkForDenial();
      const nextStepId = stepIds.value[stepIds.value.indexOf(innerCurrentStepId.value) + 1];
      if (nextStepId) {
        goToStep(nextStepId);
      }
    } else {
      globalEmit("error", [
        {
          source: "submit",
          key: "ValidationErrors",
          message: "Form not valid"
        }
      ]);
    }
  });
  const onPrevious = () => {
    if (!navigationEnabled) {
      return;
    }
    const previousStepId = stepIds.value[stepIds.value.indexOf(innerCurrentStepId.value) - 1];
    if (previousStepId) {
      goToStep(previousStepId);
    }
  };
  const isFirstStep = computed$1(() => {
    return innerCurrentStepId.value === stepIds.value[0];
  });
  const isLastStep = computed$1(() => {
    const [lastStepId] = stepIds.value.slice(-1);
    return innerCurrentStepId.value === lastStepId;
  });
  const collectStepsBefore = (stepId) => {
    const stepIndex = stepIds.value.indexOf(stepId);
    return stepIds.value.slice(0, stepIndex);
  };
  const canGoToStep = (stepId) => {
    const steps = collectStepsBefore(stepId);
    return steps.every((step) => validateStep(step, false));
  };
  watch$1(innerCurrentStepId, (value) => {
    if (!canGoToStep(value)) {
      goToStep(stepIds.value[0]);
    }
  });
  if (!canGoToStep(innerCurrentStepId.value)) {
    Vue.nextTick(() => goToStep(stepIds.value[0]));
  }
  return {
    isFirstStep,
    isLastStep,
    onPrevious,
    onNext,
    goToStep,
    innerCurrentStepId
  };
};

function scrollToFirstError$1(offset = 0) {
  const errorFirst = document.querySelector(`.${ERROR_CLASS_NAME}`);
  if (errorFirst) {
    const errorFirstInput = errorFirst.querySelector("input, select, textarea");
    errorFirst.scrollIntoView(true);
    window.scrollBy(0, -offset);
    errorFirstInput === null || errorFirstInput === void 0 ? void 0 : errorFirstInput.focus();
  }
}

var __assign$6 = Object.assign;
var script$9 = defineComponent({
  name: "GroupFieldWrapper",
  components: {},
  props: {
    formContext: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    itemComponents: {
      type: Object,
      required: true
    }
  },
  setup(props, {emit}) {
    const value = computed$1(() => {
      return props.formContext.data[props.item.dataKey];
    });
    const error = computed$1(() => {
      return props.formContext.errors[props.item.dataKey];
    });
    const visibleDescendents = computed$1(() => value.value.map((element) => {
      var _a;
      return ((_a = props.item.descendents) !== null && _a !== void 0 ? _a : []).filter((descendent) => descendent.__typename !== "GroupField" && (!isField(descendent) || isDescendentFieldVisible(props.item, descendent, props.formContext, element)));
    }));
    const addIdSuffix = (descendent, index) => __assign$6(__assign$6({}, descendent), {
      id: `${descendent.id}[${index}]`
    });
    const onValidateDescendent = (parsedPath, index) => {
      emit("validate", {
        dataKey: props.item.dataKey,
        index,
        descendentDataKey: parsedPath.dataKey,
        propKey: parsedPath.propKey
      });
    };
    return {
      value,
      error,
      visibleDescendents,
      addIdSuffix,
      onValidateDescendent
    };
  }
});

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier /* server only */, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
    if (typeof shadowMode !== 'boolean') {
        createInjectorSSR = createInjector;
        createInjector = shadowMode;
        shadowMode = false;
    }
    // Vue.extend constructor export interop.
    const options = typeof script === 'function' ? script.options : script;
    // render functions
    if (template && template.render) {
        options.render = template.render;
        options.staticRenderFns = template.staticRenderFns;
        options._compiled = true;
        // functional template
        if (isFunctionalTemplate) {
            options.functional = true;
        }
    }
    // scopedId
    if (scopeId) {
        options._scopeId = scopeId;
    }
    let hook;
    if (moduleIdentifier) {
        // server build
        hook = function (context) {
            // 2.3 injection
            context =
                context || // cached call
                    (this.$vnode && this.$vnode.ssrContext) || // stateful
                    (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext); // functional
            // 2.2 with runInNewContext: true
            if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
                context = __VUE_SSR_CONTEXT__;
            }
            // inject component styles
            if (style) {
                style.call(this, createInjectorSSR(context));
            }
            // register component module identifier for async chunk inference
            if (context && context._registeredComponents) {
                context._registeredComponents.add(moduleIdentifier);
            }
        };
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        options._ssrRegister = hook;
    }
    else if (style) {
        hook = shadowMode
            ? function (context) {
                style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot));
            }
            : function (context) {
                style.call(this, createInjector(context));
            };
    }
    if (hook) {
        if (options.functional) {
            // register for functional component in vue file
            const originalRender = options.render;
            options.render = function renderWithStyleInjection(h, context) {
                hook.call(context);
                return originalRender(h, context);
            };
        }
        else {
            // inject component registration as beforeCreate hook
            const existing = options.beforeCreate;
            options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
        }
    }
    return script;
}

/* script */
const __vue_script__$9 = script$9;

/* template */
var __vue_render__$9 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.itemComponents['GroupField'],{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.item,"value":_vm.value,"error":_vm.error},on:{"validate":function($event){return _vm.$emit('validate', $event)}},scopedSlots:_vm._u([{key:"element",fn:function(ref){
var index = ref.index;
var elementValue = ref.elementValue;
var elementErrors = ref.elementErrors;
return _vm._l((_vm.visibleDescendents[index]),function(descendent){return _c(_vm.itemComponents[descendent.__typename],{key:descendent.id,tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.addIdSuffix(descendent, index),"value":elementValue[descendent.dataKey],"error":elementErrors && elementErrors[descendent.dataKey]
          ? elementErrors[descendent.dataKey]
          : null},on:{"input":function($event){elementValue[descendent.dataKey] = $event;},"validate":function($event){return _vm.onValidateDescendent($event, index)}}})})}}])})};
var __vue_staticRenderFns__$9 = [];

  /* style */
  const __vue_inject_styles__$9 = undefined;
  /* scoped */
  const __vue_scope_id__$9 = undefined;
  /* module identifier */
  const __vue_module_identifier__$9 = undefined;
  /* functional template */
  const __vue_is_functional_template__$9 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$9 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$9, staticRenderFns: __vue_staticRenderFns__$9 },
    __vue_inject_styles__$9,
    __vue_script__$9,
    __vue_scope_id__$9,
    __vue_is_functional_template__$9,
    __vue_module_identifier__$9,
    false,
    undefined,
    undefined,
    undefined
  );

var __assign$5 = Object.assign;
var script$8 = defineComponent({
  name: "ContentItemWrapper",
  props: {
    formContext: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    itemComponents: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const renderedConfig = computed$1(() => {
      var _a;
      return __assign$5(__assign$5({}, props.item), {
        richText: props.formContext.renderHtml((_a = props.item.richText) !== null && _a !== void 0 ? _a : "")
      });
    });
    return {renderedConfig};
  }
});

/* script */
const __vue_script__$8 = script$8;

/* template */
var __vue_render__$8 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.itemComponents['ContentItem'],{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.renderedConfig}})],1)};
var __vue_staticRenderFns__$8 = [];

  /* style */
  const __vue_inject_styles__$8 = undefined;
  /* scoped */
  const __vue_scope_id__$8 = undefined;
  /* module identifier */
  const __vue_module_identifier__$8 = undefined;
  /* functional template */
  const __vue_is_functional_template__$8 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$8 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$8, staticRenderFns: __vue_staticRenderFns__$8 },
    __vue_inject_styles__$8,
    __vue_script__$8,
    __vue_scope_id__$8,
    __vue_is_functional_template__$8,
    __vue_module_identifier__$8,
    false,
    undefined,
    undefined,
    undefined
  );

var SummaryMode;
(function(SummaryMode2) {
  SummaryMode2["summarized"] = "summarized";
  SummaryMode2["edit"] = "edit";
})(SummaryMode || (SummaryMode = {}));

var __assign$4 = Object.assign;
var script$7 = defineComponent({
  name: "SummaryItemWrapper",
  props: {
    formContext: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    itemComponents: {
      type: Object,
      required: true
    }
  },
  setup(props, {emit}) {
    const isEditMode = ref$1(props.item.initiallyOpen);
    watch$1(() => props.item.initiallyOpen, (newValue) => {
      isEditMode.value = newValue;
    });
    useFormBuilderEvents({
      changeSummaryMode: ({mode, id}) => {
        if (String(id) === props.item.id) {
          isEditMode.value = mode === SummaryMode.edit;
        }
      }
    });
    const onEditMode = (newValue) => {
      isEditMode.value = newValue;
    };
    const visibleEditableItemIds = computed$1(() => {
      return props.item.editableItemIds.filter((id) => {
        const item = props.formContext.schema.items[id];
        return isItemVisible(item, props.formContext);
      });
    });
    const visibleEditableItems = computed$1(() => visibleEditableItemIds.value.map((id) => props.formContext.schema.items[id]));
    const visibleShownItemIds = computed$1(() => {
      return props.item.shownItemIds.filter((id) => {
        const item = props.formContext.schema.items[id];
        return isItemVisible(item, props.formContext);
      });
    });
    const visibleShownItems = computed$1(() => {
      return Object.fromEntries(visibleShownItemIds.value.map((id) => {
        var _a;
        const item = props.formContext.schema.items[id];
        return [
          id,
          __assign$4(__assign$4({}, item), {
            value: "dataKey" in item ? (_a = props.formContext.data[item.dataKey]) !== null && _a !== void 0 ? _a : null : null
          })
        ];
      }));
    });
    watch$1(props.formContext.errors, (formErrors) => {
      if (!isEditMode.value && visibleEditableItems.value.some((item) => isField(item) && formErrors[item.dataKey])) {
        isEditMode.value = true;
      }
    });
    const onValidate = (path) => {
      emit("validate", path);
    };
    const innerItem = computed$1(() => {
      return __assign$4(__assign$4({}, props.item), {
        shownItemIds: visibleShownItemIds.value
      });
    });
    return {
      isEditMode,
      onEditMode,
      visibleEditableItemIds,
      visibleShownItemIds,
      visibleShownItems,
      onValidate,
      innerItem
    };
  },
  beforeCreate() {
    if (this.$options.components) {
      this.$options.components.Item = Item;
    }
  }
});

/* script */
const __vue_script__$7 = script$7;

/* template */
var __vue_render__$7 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visibleShownItemIds.length || _vm.visibleEditableItemIds.length)?_c(_vm.itemComponents['SummaryItem'],{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.innerItem,"summary-items":_vm.visibleShownItems,"is-edit-mode":_vm.isEditMode},on:{"editMode":_vm.onEditMode}},_vm._l((_vm.visibleEditableItemIds),function(itemId){return _c('Item',{key:itemId,attrs:{"item-id":itemId,"item-components":_vm.itemComponents},on:{"validate":_vm.onValidate}})}),1):_vm._e()};
var __vue_staticRenderFns__$7 = [];

  /* style */
  const __vue_inject_styles__$7 = undefined;
  /* scoped */
  const __vue_scope_id__$7 = undefined;
  /* module identifier */
  const __vue_module_identifier__$7 = undefined;
  /* functional template */
  const __vue_is_functional_template__$7 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$7 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$7, staticRenderFns: __vue_staticRenderFns__$7 },
    __vue_inject_styles__$7,
    __vue_script__$7,
    __vue_scope_id__$7,
    __vue_is_functional_template__$7,
    __vue_module_identifier__$7,
    false,
    undefined,
    undefined,
    undefined
  );

var __assign$3 = Object.assign;
var __async$2 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var script$6 = defineComponent({
  name: "ModuleSelectFieldWrapper",
  props: {
    formContext: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    itemComponents: {
      type: Object,
      required: true
    },
    error: {
      type: Object,
      default: null
    }
  },
  setup(props, {emit}) {
    const filterItems = (itemIds) => {
      return itemIds.filter((id) => {
        const item = props.formContext.schema.items[id];
        return isItemVisible(item, props.formContext);
      });
    };
    const filteredItem = computed$1(() => __assign$3(__assign$3({}, props.item), {
      modules: props.item.modules.filter((module) => isModuleVisible(module, props.formContext))
    }));
    const onSelectOnlyModule = (moduleKey) => __async$2(this, null, function* () {
      props.formContext.updateSelectedModules(props.item.modules.map((module) => ({
        key: module.key,
        addOn: module.addOn,
        selected: module.key === moduleKey
      })));
      if (props.error) {
        emit("validate", {dataKey: props.error.dataKey});
      }
    });
    const onUpdateModule = (moduleKey, selected) => __async$2(this, null, function* () {
      props.formContext.updateSelectedModules(props.item.modules.filter((module) => module.key === moduleKey).map((module) => ({
        key: module.key,
        addOn: module.addOn,
        selected
      })));
      if (props.error) {
        emit("validate", {dataKey: props.error.dataKey});
      }
    });
    const onValidate = (path) => {
      emit("validate", path);
    };
    return {filteredItem, filterItems, onSelectOnlyModule, onUpdateModule, onValidate};
  },
  beforeCreate() {
    if (this.$options.components) {
      this.$options.components.Item = Item;
    }
  }
});

/* script */
const __vue_script__$6 = script$6;

/* template */
var __vue_render__$6 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.itemComponents['ModuleSelectionField'],{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.filteredItem,"error":_vm.error},on:{"select-only-module":_vm.onSelectOnlyModule,"update-module":_vm.onUpdateModule},scopedSlots:_vm._u([{key:"items",fn:function(ref){
var itemIds = ref.itemIds;
return _vm._l((_vm.filterItems(itemIds)),function(itemId){return _c('Item',{key:itemId,attrs:{"item-id":itemId,"item-components":_vm.itemComponents},on:{"validate":_vm.onValidate}})})}}])})};
var __vue_staticRenderFns__$6 = [];

  /* style */
  const __vue_inject_styles__$6 = undefined;
  /* scoped */
  const __vue_scope_id__$6 = undefined;
  /* module identifier */
  const __vue_module_identifier__$6 = undefined;
  /* functional template */
  const __vue_is_functional_template__$6 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$6 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$6, staticRenderFns: __vue_staticRenderFns__$6 },
    __vue_inject_styles__$6,
    __vue_script__$6,
    __vue_scope_id__$6,
    __vue_is_functional_template__$6,
    __vue_module_identifier__$6,
    false,
    undefined,
    undefined,
    undefined
  );

var __assign$2 = Object.assign;
var script$5 = defineComponent({
  name: "RowItemWrapper",
  props: {
    formContext: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    itemComponents: {
      type: Object,
      required: true
    }
  },
  setup(props, {emit}) {
    const innerConfig = computed$1(() => {
      var _a, _b;
      return __assign$2(__assign$2({}, props.item), {
        itemIds: (_b = (_a = props.item.itemIds) === null || _a === void 0 ? void 0 : _a.filter((id) => {
          const item = props.formContext.schema.items[id];
          return isItemVisible(item, props.formContext);
        })) !== null && _b !== void 0 ? _b : []
      });
    });
    const onValidate = (path) => {
      emit("validate", path);
    };
    return {
      innerConfig,
      onValidate
    };
  },
  beforeCreate() {
    if (this.$options.components) {
      this.$options.components.Item = Item;
    }
  }
});

/* script */
const __vue_script__$5 = script$5;

/* template */
var __vue_render__$5 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.innerConfig.itemIds.length)?_c(_vm.itemComponents['RowItem'],{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.innerConfig}},_vm._l((_vm.innerConfig.itemIds),function(itemId){return _c('Item',{key:itemId,attrs:{"item-id":itemId,"item-components":_vm.itemComponents},on:{"validate":_vm.onValidate}})}),1):_vm._e()};
var __vue_staticRenderFns__$5 = [];

  /* style */
  const __vue_inject_styles__$5 = undefined;
  /* scoped */
  const __vue_scope_id__$5 = undefined;
  /* module identifier */
  const __vue_module_identifier__$5 = undefined;
  /* functional template */
  const __vue_is_functional_template__$5 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$5 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$5, staticRenderFns: __vue_staticRenderFns__$5 },
    __vue_inject_styles__$5,
    __vue_script__$5,
    __vue_scope_id__$5,
    __vue_is_functional_template__$5,
    __vue_module_identifier__$5,
    false,
    undefined,
    undefined,
    undefined
  );

const TRUE_VALUE_STRING = "$true";
const FALSE_VALUE_STRING = "$false";

var script$4 = defineComponent({
  name: "RadioGroupFieldWrapper",
  props: {
    formContext: {
      type: Object,
      required: true
    },
    item: {
      type: Object,
      required: true
    },
    value: {
      type: [String, Boolean],
      default: null
    },
    error: {
      type: Object,
      default: null
    },
    itemComponents: {
      type: Object,
      required: true
    }
  },
  setup(props, {emit}) {
    const valueAsString = computed$1(() => {
      if (props.value === true) {
        return TRUE_VALUE_STRING;
      }
      if (props.value === false) {
        return FALSE_VALUE_STRING;
      }
      return props.value;
    });
    const onInput = (newValue) => {
      if (newValue === TRUE_VALUE_STRING) {
        emit("input", true);
      } else if (newValue === FALSE_VALUE_STRING) {
        emit("input", false);
      } else {
        emit("input", newValue);
      }
    };
    return {valueAsString, onInput};
  }
});

/* script */
const __vue_script__$4 = script$4;

/* template */
var __vue_render__$4 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm.itemComponents['RadioGroupField'],{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.item,"value":_vm.valueAsString,"error":_vm.error},on:{"input":_vm.onInput,"validate":function($event){return _vm.$emit('validate', $event)}}})],1)};
var __vue_staticRenderFns__$4 = [];

  /* style */
  const __vue_inject_styles__$4 = undefined;
  /* scoped */
  const __vue_scope_id__$4 = undefined;
  /* module identifier */
  const __vue_module_identifier__$4 = undefined;
  /* functional template */
  const __vue_is_functional_template__$4 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$4 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$4, staticRenderFns: __vue_staticRenderFns__$4 },
    __vue_inject_styles__$4,
    __vue_script__$4,
    __vue_scope_id__$4,
    __vue_is_functional_template__$4,
    __vue_module_identifier__$4,
    false,
    undefined,
    undefined,
    undefined
  );

const wrapperComponents = {
  GroupField: __vue_component__$9,
  ContentItem: __vue_component__$8,
  SummaryItem: __vue_component__$7,
  ModuleSelectionField: __vue_component__$6,
  RowItem: __vue_component__$5,
  RadioGroupField: __vue_component__$4
};
var script$3 = defineComponent({
  name: "Item",
  props: {
    itemId: {
      type: String,
      required: true
    },
    itemComponents: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const formContext = useFormContext();
    const item = computed$1(() => formContext.value.schema.items[props.itemId]);
    const component = computed$1(() => {
      if (!item.value) {
        return null;
      }
      return props.itemComponents[item.value.__typename];
    });
    const wrapperComponent = computed$1(() => {
      if (!item.value || !(item.value.__typename in wrapperComponents))
        return null;
      return wrapperComponents[item.value.__typename];
    });
    const error = computed$1(() => {
      const itemValue = item.value;
      return isField(itemValue) ? formContext.value.errors[itemValue.dataKey] : null;
    });
    const onInput = (inputValue) => {
      const itemObject = item.value;
      if (isField(itemObject)) {
        formContext.value.updateField(itemObject.dataKey, inputValue);
      }
    };
    const hasWrapperComponent = computed$1(() => {
      if (!item.value) {
        return false;
      }
      return item.value.__typename in wrapperComponents;
    });
    const value = computed$1(() => {
      const itemValue = item.value;
      if (isField(itemValue)) {
        return formContext.value.data[itemValue.dataKey];
      }
      return "";
    });
    return {
      formContext,
      component,
      item,
      value,
      error,
      onInput,
      hasWrapperComponent,
      wrapperComponents,
      wrapperComponent
    };
  }
});

/* script */
const __vue_script__$3 = script$3;

/* template */
var __vue_render__$3 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasWrapperComponent)?_c(_vm.wrapperComponent,{tag:"Component",attrs:{"form-context":_vm.formContext,"item-components":_vm.itemComponents,"item":_vm.item,"value":_vm.value,"error":_vm.error},on:{"input":_vm.onInput,"validate":function($event){return _vm.$emit('validate', $event)}}}):_c(_vm.component,{tag:"Component",attrs:{"form-context":_vm.formContext,"item":_vm.item,"value":_vm.value,"error":_vm.error},on:{"input":_vm.onInput,"validate":function($event){return _vm.$emit('validate', $event)}}})};
var __vue_staticRenderFns__$3 = [];

  /* style */
  const __vue_inject_styles__$3 = undefined;
  /* scoped */
  const __vue_scope_id__$3 = undefined;
  /* module identifier */
  const __vue_module_identifier__$3 = undefined;
  /* functional template */
  const __vue_is_functional_template__$3 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$3 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$3, staticRenderFns: __vue_staticRenderFns__$3 },
    __vue_inject_styles__$3,
    __vue_script__$3,
    __vue_scope_id__$3,
    __vue_is_functional_template__$3,
    __vue_module_identifier__$3,
    false,
    undefined,
    undefined,
    undefined
  );

  var Item = __vue_component__$3;

var __assign$1 = Object.assign;
var __async$1 = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const scrollToFirstError = (...args) => requestAnimationFrame(() => scrollToFirstError$1(...args));
var script$2 = defineComponent({
  name: "Form",
  components: {
    Item
  },
  props: {
    schema: {type: Object, required: true},
    channel: {type: String, required: true},
    language: {type: String, default: ""},
    itemComponents: {type: Object, required: true},
    initialData: {type: Object, default: null},
    currentStepId: {type: String, default: void 0},
    initialStepId: {type: String, default: void 0},
    serverErrors: {type: Array, required: true},
    isPriceLoading: {type: Boolean, required: true},
    isLoading: {type: Boolean, required: true},
    tariff: {type: Object, default: null},
    tariffError: {type: Object, default: null},
    shouldCheckDeny: {type: Boolean, required: true},
    formMode: {type: String, required: true},
    scrollErrorTopOffset: {type: Number, default: 0}
  },
  setup(props, {emit}) {
    const data = reactive$1(__assign$1(__assign$1({}, props.schema.initialData), props.initialData));
    const {errors, isValid, validateStep, validateAll, validateFields, validateSaveRequiredFields} = useFormValidation({
      data,
      schema: props.schema,
      serverErrors: toRef(props, "serverErrors"),
      tariff: toRef(props, "tariff"),
      formMode: props.formMode
    });
    const globalEmit = useGlobalEmit();
    const checkForDenial = useCheckForDenial({
      data,
      schema: toRef(props, "schema"),
      shouldCheckDeny: toRef(props, "shouldCheckDeny"),
      channel: toRef(props, "channel")
    });
    const {visibleItemsByStep, visibleStepIds, visibleSteps} = useVisibility({
      schema: toRef(props, "schema"),
      data,
      tariff: toRef(props, "tariff"),
      formMode: props.formMode
    });
    const {resolveClient} = useApolloClient();
    const getDataToSubmit = (allData) => {
      const dataEntriesWithoutFields = Object.entries(allData).filter(([dataKey]) => {
        return getFieldsForData(props.schema, dataKey).length === 0;
      });
      const seenFieldDataEntries = Object.entries(allData).map(([dataKey, value]) => {
        const visibilityContext = {schema: props.schema, data: allData, tariff: props.tariff};
        const visibleFields = getFieldsForData(props.schema, dataKey).filter((field) => isItemVisible(field, visibilityContext));
        if (visibleFields.length === 0) {
          return null;
        }
        if (visibleFields.every((field) => field.__typename === "GroupField") && Array.isArray(value)) {
          return [
            dataKey,
            value.map((element) => filterGroupElementByVisibility(element, visibleFields, visibilityContext))
          ];
        }
        return [dataKey, value];
      }).filter(notEmpty);
      return Object.fromEntries([...dataEntriesWithoutFields, ...seenFieldDataEntries]);
    };
    watch$1(data, (value) => {
      emit("update", getDataToSubmit(value));
    });
    watch$1(() => props.initialData, (newInitialData) => {
      if (newInitialData) {
        Object.assign(data, newInitialData);
        emit("start", getDataToSubmit(data));
      }
    }, {immediate: true});
    const {isFirstStep, isLastStep, onPrevious, onNext, innerCurrentStepId} = useFormSteps({
      currentStepId: toRef(props, "currentStepId"),
      initialStepId: props.initialStepId,
      stepIds: visibleStepIds,
      validateStep,
      checkForDenial,
      getFormContext: () => formContext.value,
      navigationEnabled: props.formMode !== FormMode.formBuilder
    });
    const onSubmit = () => {
      if (!isLastStep.value) {
        onNext();
        scrollToFirstError(props.scrollErrorTopOffset);
        return;
      }
      if (props.isPriceLoading) {
        return;
      }
      validateAll();
      if (isValid.value) {
        emit("submit", getDataToSubmit(data));
      } else {
        scrollToFirstError(props.scrollErrorTopOffset);
        globalEmit("error", [
          {
            source: "submit",
            key: "ValidationErrors",
            message: "Form not valid"
          }
        ]);
      }
    };
    const globalError = computed$1(() => errors[GLOBAL_ERROR_KEY]);
    const globalErrorComponent = props.itemComponents.GlobalErrorMessage;
    let navigateOnInputTimeoutId;
    const texts = computed$1(() => Object.fromEntries(props.schema.globalTexts.map((text) => [text.key, text.text])));
    const formContext = computed$1(() => {
      const contextData = {
        schema: props.schema,
        data,
        errors,
        isPriceLoading: props.isPriceLoading,
        tariff: props.tariff,
        tariffError: props.tariffError,
        serverErrors: props.serverErrors,
        selectedModules: [...getModuleKeys(data, false), ...getModuleKeys(data, true)]
      };
      const navigateOnInputIfShould = () => {
        var _a;
        if ((_a = props.schema.steps[props.currentStepId]) === null || _a === void 0 ? void 0 : _a.navigateOnInput) {
          window.clearTimeout(navigateOnInputTimeoutId);
          navigateOnInputTimeoutId = window.setTimeout(onNext, 0);
        }
      };
      return __assign$1(__assign$1({}, contextData), {
        t: (key, values) => t(texts.value, key, values),
        tc: (key, count, values) => tc(texts.value, key, count, values),
        te: (key) => te(texts.value, key),
        updateField: (dataKey, value) => {
          data[dataKey] = value;
          deselectInvisibleModules(formContext.value);
          navigateOnInputIfShould();
        },
        updateSelectedModules: (modulesToUpdate) => {
          modulesToUpdate.forEach((module) => {
            const dataKey = module.addOn ? SELECTED_ADD_ON_MODULES_KEY : SELECTED_MAIN_MODULES_KEY;
            const selectedModules = data[dataKey];
            if (!module.selected) {
              data[dataKey] = selectedModules.filter((currentModuleKey) => currentModuleKey !== module.key);
            } else if (!selectedModules.includes(module.key)) {
              data[dataKey] = [...selectedModules, module.key];
            }
          });
          deselectInvisibleModules(formContext.value);
          navigateOnInputIfShould();
        },
        getDocument(downloadItem) {
          return __async$1(this, null, function* () {
            var _a, _b;
            const {product} = props.schema;
            const params = {
              product: {
                productKey: product.productKey,
                variantKey: product.variantKey,
                versionNumber: product.versionNumber
              },
              channel: props.channel,
              formLanguage: props.language,
              documentTypeKey: downloadItem.documentTypeKey,
              documentLanguage: (_a = downloadItem.languageKey) !== null && _a !== void 0 ? _a : props.language,
              kind: downloadItem.kind,
              data: formatToApplicationDataInput(props.schema, getDataToSubmit(data), false),
              totalPremium: ((_b = props.tariff) === null || _b === void 0 ? void 0 : _b.totalPremium) && {
                currency: props.tariff.totalPremium.currency,
                valueCents: props.tariff.totalPremium.valueCents
              }
            };
            const apolloClient = resolveClient();
            const {data: result} = yield apolloClient.query({
              query: ApplicationDocumentDocument,
              variables: {input: params}
            });
            if (result.applicationDocument.__typename !== "ApplicationDocument" && result.applicationDocument.__typename !== "BusinessLogicError") {
              throw new Error(`Cannot get application document for ${JSON.stringify(params)}: ${result.applicationDocument.message}`);
            }
            if (result.applicationDocument.__typename === "ApplicationDocument" && result.applicationDocument.id && result.applicationDocument.file.fileName) {
              const documentId = result.applicationDocument.id;
              const duplicateDocument = data[DOCUMENT_IDS_KEY].find((document) => document.typeKey === downloadItem.documentTypeKey);
              if (duplicateDocument) {
                duplicateDocument.id = documentId;
              } else {
                data[DOCUMENT_IDS_KEY].push({
                  typeKey: downloadItem.documentTypeKey,
                  id: documentId
                });
              }
            }
            return result.applicationDocument;
          });
        },
        renderHtml: (template) => {
          const dataByModule = {};
          Object.entries(data).forEach(([dataKey, value]) => {
            const [moduleKey, attributeKey] = dataKey.split(".");
            if (!dataByModule[moduleKey]) {
              dataByModule[moduleKey] = {};
            }
            dataByModule[moduleKey][attributeKey] = value;
          });
          const formatDate = () => (text, render) => {
            const [value, pattern] = (text || "").split(" ");
            if (!value || !pattern) {
              return "";
            }
            const renderedValue = render(`\${${value.trim()}}`);
            if (renderedValue !== "") {
              return format(new Date(renderedValue), pattern.trim());
            }
            return "";
          };
          const formatMoney$1 = () => (text) => {
            const path = text.split(".");
            const value = getObjectValue(path, contextData);
            if (!value) {
              return "";
            }
            return formatMoney(value);
          };
          return Mustache.render(template, __assign$1(__assign$1({}, contextData), {data: dataByModule, formatDate, formatMoney: formatMoney$1}), {}, ["${", "}"]);
        }
      });
    });
    const onSave = () => {
      if (props.isPriceLoading) {
        return;
      }
      validateSaveRequiredFields();
      if (!isValid.value) {
        globalEmit("error", [
          {
            source: "save",
            key: "ValidationErrors",
            message: "Form not valid"
          }
        ]);
        return;
      }
      emit("save", getDataToSubmit(data));
    };
    provideFormContext(formContext);
    const onValidateField = (parsedPath) => {
      validateFields([renderPath(parsedPath)], ["required"]);
    };
    const isTariffVisible = computed$1(() => {
      var _a, _b, _c;
      return ((_a = props.schema.steps[props.currentStepId]) === null || _a === void 0 ? void 0 : _a.showTariff) === true && typeof ((_c = (_b = props.tariff) === null || _b === void 0 ? void 0 : _b.totalPremium) === null || _c === void 0 ? void 0 : _c.valueCents) === "number";
    });
    useFormBuilderEvents({
      navigateToStep: (stepId) => {
        if (props.currentStepId !== stepId) {
          window.scrollTo(0, 0);
        }
        globalEmit("goToStep", {stepId, formContext: formContext.value});
      }
    });
    useFormBuilderEvents({
      restrictInteractivity: (eventData) => {
        eventData.options.forEach((option) => {
          window.document.querySelectorAll(option.element)[0].style.pointerEvents = option.style;
        });
      }
    });
    return {
      formContext,
      data,
      onSubmit,
      errors,
      onPrevious,
      onNext,
      innerCurrentStepId,
      isFirstStep,
      isLastStep,
      globalError,
      globalErrorComponent,
      visibleItemsByStep,
      visibleStepIds,
      visibleSteps,
      onSave,
      onValidateField,
      isTariffVisible
    };
  }
});

/* script */
const __vue_script__$2 = script$2;

/* template */
var __vue_render__$2 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.schema.steps[_vm.innerCurrentStepId])?_c('form',{on:{"submit":function($event){$event.preventDefault();return _vm.onSubmit.apply(null, arguments)}}},[_c('div',[_vm._t("header",function(){return [_c('h2',[_vm._v(_vm._s(_vm.schema.steps[_vm.innerCurrentStepId].title))]),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.schema.steps[_vm.innerCurrentStepId].subtitle))])]},null,{
          formContext: _vm.formContext,
          steps: _vm.visibleSteps,
          current: _vm.innerCurrentStepId,
        }),_vm._v(" "),(_vm.globalError)?_c(_vm.globalErrorComponent,{tag:"Component",attrs:{"form-context":_vm.formContext,"error":_vm.globalError}}):_vm._e(),_vm._v(" "),_vm._l((_vm.visibleItemsByStep[_vm.innerCurrentStepId]),function(itemId){return _c('Item',{key:itemId,attrs:{"item-id":itemId,"item-components":_vm.itemComponents},on:{"validate":_vm.onValidateField}})}),_vm._v(" "),_c('div',[_vm._t("formNavigation",function(){return [(!_vm.isFirstStep)?_c('button',{key:"previous",attrs:{"type":"button"},on:{"click":_vm.onPrevious}},[_vm._v("\n            Previous\n          ")]):_vm._e(),_vm._v(" "),_c('button',{key:"submit",attrs:{"type":"submit","disabled":_vm.isLastStep && _vm.isPriceLoading}},[_vm._v("\n            "+_vm._s(_vm.isLastStep ? 'Submit' : 'Next')+"\n          ")])]},null,{
            formContext: _vm.formContext,
            isFirstStep: _vm.isFirstStep,
            isLastStep: _vm.isLastStep,
            isPriceLoading: _vm.isPriceLoading,
            onPrevious: _vm.onPrevious,
            onSave: _vm.onSave,
            currentStep: _vm.schema.steps[_vm.currentStepId],
          })],2)],2)]):_vm._e(),_vm._v(" "),(_vm.isTariffVisible)?_vm._t("tariff",null,null,_vm.formContext):_vm._e(),_vm._v(" "),(_vm.isLoading)?_vm._t("loadingIndicator",null,null,_vm.formContext):_vm._e()],2)};
var __vue_staticRenderFns__$2 = [];

  /* style */
  const __vue_inject_styles__$2 = undefined;
  /* scoped */
  const __vue_scope_id__$2 = undefined;
  /* module identifier */
  const __vue_module_identifier__$2 = undefined;
  /* functional template */
  const __vue_is_functional_template__$2 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$2 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$2, staticRenderFns: __vue_staticRenderFns__$2 },
    __vue_inject_styles__$2,
    __vue_script__$2,
    __vue_scope_id__$2,
    __vue_is_functional_template__$2,
    __vue_module_identifier__$2,
    false,
    undefined,
    undefined,
    undefined
  );

var __assign = Object.assign;
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (result) => {
      return result.done ? resolve(result.value) : Promise.resolve(result.value).then(fulfilled, rejected);
    };
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
const isApplicationPrice = (value) => value.__typename === "ApplicationPrice";
function isModuleSelectionItem(item) {
  return item.__typename === "ModuleSelectionField";
}
function warnWhenVersionsDontMatch(apiVersion) {
  if (!apiVersion) {
    return;
  }
  if (apiVersion !== "2.0.9") {
    throw new Error(`version: ${"2.0.9"} of @scip-sales/application-form doesen't match version of SCIP-Sales services: ${apiVersion}. This would result in unwanted behavior. Please make sure @scip-sales/application-form and all other SCIP-Sales services have the same version`);
  }
}
var script$1 = defineComponent({
  name: "FormServiceWrapper",
  components: {
    Form: __vue_component__$2
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    channel: {
      type: String,
      required: true
    },
    language: {
      type: String,
      default: ""
    },
    quoteId: {
      type: String,
      default: null
    },
    policyId: {
      type: String,
      default: null
    },
    amendmentId: {
      type: String,
      default: null
    },
    formKey: {
      type: String,
      default: null
    },
    initialData: {
      type: Object,
      default: () => ({})
    },
    currentStepId: {
      type: String,
      default: void 0
    },
    itemComponents: {
      type: Object,
      required: true
    },
    testMode: {
      type: Boolean,
      default: false
    },
    shouldCheckDeny: {
      type: Boolean,
      default: false
    },
    isResumeModalOpen: {
      type: Boolean,
      default: false
    },
    shouldResume: {
      type: Boolean,
      default: false
    },
    scrollErrorTopOffset: {
      type: Number,
      default: 0
    }
  },
  setup(props, {emit}) {
    provideGlobalEmit(emit);
    const language = computed$1(() => {
      return props.language ? props.language : null;
    });
    const queryVariables = computed$1(() => ({
      input: {
        product: props.product,
        channel: props.channel,
        language: language.value,
        quoteId: props.quoteId,
        policyId: props.policyId,
        amendmentId: props.amendmentId,
        formKey: props.formKey
      }
    }));
    const formMode = getFormMode();
    const applicationFormQuery = useApplicationFormQuery(queryVariables, {
      fetchPolicy: "no-cache",
      enabled: formMode !== FormMode.formBuilder
    });
    const serverErrors = ref$1([]);
    const handleServerErrors = (newErrors) => {
      serverErrors.value = newErrors;
      emit("error", newErrors);
    };
    applicationFormQuery.onError((e) => {
      var _a;
      handleServerErrors([
        {
          key: "General_Error",
          message: (_a = e === null || e === void 0 ? void 0 : e.message) !== null && _a !== void 0 ? _a : "GQL Error",
          source: "loadApplicationForm"
        }
      ]);
    });
    const schema = ref$1(null);
    const resumeFormData = ref$1(null);
    watch$1(applicationFormQuery.result, (result) => {
      if (!(result === null || result === void 0 ? void 0 : result.applicationForm)) {
        handleServerErrors([
          {
            key: "General_Error",
            message: "empty response",
            source: "loadApplicationForm"
          }
        ]);
        schema.value = null;
      } else if (result.applicationForm.__typename === "ApplicationForm") {
        warnWhenVersionsDontMatch(result.applicationForm.__scipSalesVersion);
        schema.value = normalizeSchema(result.applicationForm);
        emit("ready", {versionNumber: result.applicationForm.product.versionNumber});
        const localStorageData = loadDataLocally();
        if (result.applicationForm.options.resumable && !props.quoteId && !props.policyId && !props.amendmentId && localStorageData && localStorageData.productKey === props.product.productKey && localStorageData.variantKey === props.product.variantKey && localStorageData.versionNumber === props.product.versionNumber && localStorageData.channel === props.channel && formMode !== FormMode.formBuilder) {
          resumeFormData.value = localStorageData;
          emit("resumable-form-exists");
        } else {
          resumeFormData.value = null;
        }
      } else if ("message" in result.applicationForm) {
        handleServerErrors([
          {
            key: result.applicationForm.__typename || "General_Error",
            message: result.applicationForm.message,
            source: "loadApplicationForm"
          }
        ]);
        schema.value = null;
      }
    });
    const resumedAndProvidedData = computed$1(() => {
      var _a;
      return __assign(__assign({}, (_a = props.initialData) !== null && _a !== void 0 ? _a : {}), resumeFormData.value && props.shouldResume ? resumeFormData.value.data : {});
    });
    watch$1(() => props.isResumeModalOpen, (newValue, oldValue) => {
      const modalJustClosed = oldValue && !newValue;
      if (modalJustClosed && !props.shouldResume) {
        saveDataLocally(null);
      }
    });
    useFormBuilderEvents({
      updateSchema: (newSchema) => {
        const firstUpdate = !schema.value;
        schema.value = normalizeSchema(newSchema);
        if (firstUpdate) {
          emit("ready", {versionNumber: newSchema.product.versionNumber});
        }
      }
    });
    const isPriceLoading = ref$1(false);
    const tariff = ref$1(null);
    const tariffError = ref$1(null);
    function clearPrice() {
      tariff.value = null;
      tariffError.value = null;
    }
    watch$1(schema, clearPrice);
    watch$1(() => props.product, clearPrice);
    const isLoading = computed$1(() => applicationFormQuery.loading.value || sendApplicationMutation.loading.value || saveApplicationMutation.loading.value);
    const priceQueryData = ref$1([]);
    const priceQueryInput = ref$1({
      input: {
        product: props.product,
        data: priceQueryData.value,
        channel: props.channel
      }
    });
    const {result: priceResult} = useApplicationPriceQuery(priceQueryInput, () => ({
      debounce: 500,
      fetchPolicy: "no-cache",
      enabled: !!priceQueryInput.value.input.product.versionNumber
    }));
    function sortPremiaByModuleOrder(premiaToSort) {
      var _a, _b;
      const moduleKeyIndex = Object.fromEntries(Object.values((_b = (_a = schema.value) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).filter(isModuleSelectionItem).flatMap((item, index) => item.modules.map((module) => [module.key, index])));
      const premia = [...premiaToSort || []];
      premia.sort((premium1, premium2) => {
        var _a2, _b2;
        const index1 = (_a2 = moduleKeyIndex[premium1.moduleKey]) !== null && _a2 !== void 0 ? _a2 : -1;
        const index2 = (_b2 = moduleKeyIndex[premium2.moduleKey]) !== null && _b2 !== void 0 ? _b2 : -1;
        return index1 - index2;
      });
      return premia;
    }
    watch$1(priceResult, (value) => {
      isPriceLoading.value = false;
      if (!value) {
        serverErrors.value = [];
        return;
      }
      const {applicationPrice} = value;
      if (!isApplicationPrice(applicationPrice)) {
        tariff.value = {
          totalPremium: null,
          premia: null,
          computedValues: {}
        };
        tariffError.value = {
          key: applicationPrice.__typename,
          message: applicationPrice.message,
          source: "tariff"
        };
        const moduleKey = "moduleKey" in applicationPrice ? applicationPrice.moduleKey : null;
        const attributeKey = "attributeKey" in applicationPrice ? applicationPrice.attributeKey : null;
        if (moduleKey && attributeKey) {
          handleServerErrors([
            {
              key: "ValidationError",
              source: "tariff",
              message: applicationPrice.message,
              attributeKey,
              moduleKey
            }
          ]);
        } else {
          serverErrors.value = [];
        }
        return;
      }
      tariff.value = {
        premia: sortPremiaByModuleOrder(applicationPrice.premia),
        totalPremium: applicationPrice.totalPremium,
        computedValues: applicationPrice.computedValues.reduce((acc, {key, value: computedValue}) => __assign(__assign({}, acc), {[key]: computedValue}), {})
      };
      tariffError.value = null;
      serverErrors.value = [];
    });
    const sendApplicationMutation = useSendApplicationMutation({});
    sendApplicationMutation.onDone(({data}) => {
      if (!data) {
        handleServerErrors([
          {
            key: "General_Error",
            message: "empty response",
            source: "submit"
          }
        ]);
        return;
      }
      switch (data.sendApplication.__typename) {
        case "ApplicationReference":
          saveDataLocally(null);
          emit("submit", {
            id: data.sendApplication.id,
            tariff,
            data: submittedData
          });
          break;
        case "MiddlewareValidationErrors":
          handleServerErrors(data.sendApplication.errors.map((error) => {
            var _a;
            return {
              source: "submit",
              key: "ValidationError",
              message: error.message,
              moduleKey: error.moduleKey,
              attributeKey: error.attributeKey,
              code: (_a = error.code) !== null && _a !== void 0 ? _a : "middleware"
            };
          }));
          break;
        default:
          handleServerErrors([
            {
              source: "submit",
              key: data.sendApplication.__typename,
              message: data.sendApplication.message,
              moduleKey: "moduleKey" in data.sendApplication ? data.sendApplication.moduleKey : null,
              attributeKey: "attributeKey" in data.sendApplication ? data.sendApplication.attributeKey : null
            }
          ]);
      }
    });
    sendApplicationMutation.onError((error) => {
      handleServerErrors([
        {
          key: "General_Error",
          message: error.message,
          source: "submit"
        }
      ]);
    });
    const saveApplicationMutation = useSaveApplicationMutation({});
    saveApplicationMutation.onDone(({data}) => {
      if (!data) {
        handleServerErrors([
          {
            key: "General_Error",
            message: "empty response",
            source: "save"
          }
        ]);
        return;
      }
      switch (data.saveApplication.__typename) {
        case "ApplicationReference":
          saveDataLocally(null);
          emit("saved", {
            id: data.saveApplication.id,
            tariff
          });
          break;
        case "MiddlewareValidationErrors":
          handleServerErrors(data.saveApplication.errors.map((error) => {
            var _a;
            return {
              source: "save",
              key: "ValidationError",
              message: error.message,
              moduleKey: error.moduleKey,
              attributeKey: error.attributeKey,
              code: (_a = error.code) !== null && _a !== void 0 ? _a : "middleware"
            };
          }));
          break;
        default:
          handleServerErrors([
            {
              source: "submit",
              key: data.saveApplication.__typename,
              message: data.saveApplication.message,
              moduleKey: "moduleKey" in data.saveApplication ? data.saveApplication.moduleKey : null,
              attributeKey: "attributeKey" in data.saveApplication ? data.saveApplication.attributeKey : null
            }
          ]);
      }
    });
    saveApplicationMutation.onError((error) => {
      handleServerErrors([
        {
          key: "General_Error",
          message: error.message,
          source: "save"
        }
      ]);
    });
    const pricingDataKeys = computed$1(() => {
      var _a, _b;
      return [
        ...Object.values((_b = (_a = schema.value) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : {}).map((item) => isField(item) && item.pricingRelevant ? item.dataKey : void 0).filter(notEmpty),
        SELECTED_MAIN_MODULES_KEY,
        SELECTED_ADD_ON_MODULES_KEY,
        ...Object.keys(props.initialData)
      ];
    });
    const uploadDataKeys = computed$1(() => {
      var _a, _b;
      return Object.values((_b = (_a = schema.value) === null || _a === void 0 ? void 0 : _a.items) !== null && _b !== void 0 ? _b : []).filter((item) => item.__typename === "UploadField").map((item) => item.dataKey);
    });
    const onData = (data, start) => {
      if (!schema.value) {
        return;
      }
      const {product, options} = schema.value;
      if (options.resumable && !start) {
        saveDataLocally({
          productKey: product.productKey,
          versionNumber: product.versionNumber,
          variantKey: product.variantKey,
          channel: props.channel,
          stepId: props.currentStepId,
          data
        }, uploadDataKeys.value);
      }
      const nextPriceQueryData = formatToApplicationDataInput(schema.value, data, false);
      const serializedPrevData = JSON.stringify(priceQueryData.value.filter((value) => pricingDataKeys.value.includes(value.dataKey)));
      const serializedNextData = JSON.stringify(nextPriceQueryData.filter((value) => pricingDataKeys.value.includes(value.dataKey)));
      priceQueryData.value = nextPriceQueryData;
      if (serializedNextData !== serializedPrevData) {
        isPriceLoading.value = true;
        tariffError.value = null;
        priceQueryInput.value = {
          input: {
            product: {
              productKey: schema.value.product.productKey,
              versionNumber: schema.value.product.versionNumber,
              variantKey: schema.value.product.variantKey
            },
            data: priceQueryData.value,
            channel: props.channel
          }
        };
      }
    };
    const onSave = (data) => __async(this, null, function* () {
      if (!schema.value) {
        return;
      }
      if (!tariff.value) {
        handleServerErrors([
          {
            key: "General_Error",
            message: "missing tariff",
            code: "tariffMissing",
            source: "save"
          }
        ]);
        return;
      }
      const {product} = schema.value;
      const formattedData = formatToApplicationDataInput(schema.value, data, true);
      yield saveApplicationMutation.mutate({
        application: {
          product: {
            productKey: product.productKey,
            versionNumber: product.versionNumber,
            variantKey: product.variantKey
          },
          channel: props.channel,
          language: language.value,
          quoteId: props.quoteId,
          policyId: props.policyId,
          amendmentId: props.amendmentId,
          data: formattedData,
          totalPremium: tariff.value.totalPremium ? {
            currency: tariff.value.totalPremium.currency,
            valueCents: tariff.value.totalPremium.valueCents
          } : null
        }
      });
    });
    const submittedData = ref$1(null);
    const onSubmit = (data) => __async(this, null, function* () {
      if (!schema.value) {
        return;
      }
      submittedData.value = data;
      if (!tariff.value) {
        handleServerErrors([
          {
            key: "General_Error",
            message: "missing tariff",
            code: "tariffMissing",
            source: "save"
          }
        ]);
        return;
      }
      const {product} = schema.value;
      const formattedData = formatToApplicationDataInput(schema.value, data, true);
      yield sendApplicationMutation.mutate({
        applicationData: {
          product: {
            productKey: product.productKey,
            versionNumber: product.versionNumber,
            variantKey: product.variantKey
          },
          channel: props.channel,
          language: language.value,
          quoteId: props.quoteId,
          policyId: props.policyId,
          amendmentId: props.amendmentId,
          testMode: props.testMode,
          data: formattedData,
          totalPremium: tariff.value.totalPremium ? {
            currency: tariff.value.totalPremium.currency,
            valueCents: tariff.value.totalPremium.valueCents
          } : null
        }
      });
    });
    return {
      schema,
      resumeFormData,
      resumedAndProvidedData,
      formMode,
      isLoading,
      isPriceLoading,
      tariff,
      tariffError,
      serverErrors,
      onData,
      onSave,
      onSubmit
    };
  }
});

/* script */
const __vue_script__$1 = script$1;

/* template */
var __vue_render__$1 = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.schema && !_vm.isResumeModalOpen)?_c('Form',{attrs:{"schema":_vm.schema,"language":_vm.language,"channel":_vm.channel,"current-step-id":_vm.currentStepId,"initial-step-id":_vm.resumeFormData && _vm.shouldResume ? _vm.resumeFormData.stepId : undefined,"item-components":_vm.itemComponents,"initial-data":_vm.resumedAndProvidedData,"server-errors":_vm.serverErrors,"is-price-loading":_vm.isPriceLoading,"is-loading":_vm.isLoading,"tariff":_vm.tariff,"tariff-error":_vm.tariffError,"should-check-deny":_vm.shouldCheckDeny,"form-mode":_vm.formMode,"scroll-error-top-offset":_vm.scrollErrorTopOffset},on:{"start":function($event){return _vm.onData($event, true)},"update":function($event){return _vm.onData($event, false)},"save":_vm.onSave,"submit":_vm.onSubmit},scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)}):_vm._e()};
var __vue_staticRenderFns__$1 = [];

  /* style */
  const __vue_inject_styles__$1 = undefined;
  /* scoped */
  const __vue_scope_id__$1 = undefined;
  /* module identifier */
  const __vue_module_identifier__$1 = undefined;
  /* functional template */
  const __vue_is_functional_template__$1 = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__$1 = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__$1, staticRenderFns: __vue_staticRenderFns__$1 },
    __vue_inject_styles__$1,
    __vue_script__$1,
    __vue_scope_id__$1,
    __vue_is_functional_template__$1,
    __vue_module_identifier__$1,
    false,
    undefined,
    undefined,
    undefined
  );

var script = defineComponent({
  name: "FormClientOnlyWrapper",
  components: {
    ClientOnly: vueClientOnly_common,
    ServiceWrapper: __vue_component__$1
  }
});

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ClientOnly',[_c('ServiceWrapper',_vm._g(_vm._b({scopedSlots:_vm._u([_vm._l((_vm.$scopedSlots),function(_,name){return {key:name,fn:function(slotData){return [_vm._t(name,null,null,slotData)]}}})],null,true)},'ServiceWrapper',_vm.$attrs,false),_vm.$listeners))],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export { __vue_component__ as ApplicationForm, ContentTypeEnum$1 as ContentTypeEnum, CurrencyEnum$1 as CurrencyEnum, DocumentKindEnum, ERROR_CLASS_NAME, SourceKind, defineCustomFormBuilderParams, formatMoney, isDescendentFieldVisible, isField, isItemVisible, provideApplicationFormContext, shouldValidate, t, tc, te };
